import Config from "Config";
import jwtDecode from "jwt-decode";
import moment from "moment-timezone";
import { Constant } from "./Constant";
import { send, sendV30 } from "./SendRequest";
import { setCurrentStep, setIamsmartFieldMap } from "./redux/action";
let math = require("mathjs");

const cloRoles = ["CLA", "CH", "C"];

export function isCLO(role) {
    return cloRoles.includes(role);
}

export function isObjectEmpty(obj) {
    if (!obj || obj.length === 0) {
        return true;
    } else {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }

        return JSON.stringify(obj) === JSON.stringify({});
    }
}
export function isFunction(test) {
    return Object.prototype.toString.call(test).indexOf("Function") > -1;
}
export function isObjectNotEmpty(obj) {
    return !isObjectEmpty(obj);
}

export function isEmpty(str) {
    return !str || str == "undefined" || str.length === 0;
}
export function isEmptyAndZero(str) {
    return !str || str == "undefined" || str.length === 0 || str == "0";
}

export function isNotEmpty(str) {
    return !isEmpty(str);
}

export function parseBool(value) {
    return value === true || value === "true";
}

// 解决加减乘除的精度问题
export function add(parameter1, parameter2) {
    // 0.1＋0.2
    return math.format(
        math
            .chain(math.bignumber(parameter1))
            .add(math.bignumber(parameter2))
            .done()
    );
}
// 解决加减乘除的精度问题
export function addMulti(parameter1, parameter2, parameter3) {
    // 0.1＋0.2
    return math.format(
        math
            .chain(math.bignumber(parameter1))
            .add(math.bignumber(parameter2))
            .add(math.bignumber(parameter3))
            .done()
    );
}

//替换开头为0的数字
export function removeZero(value) {
    if (value.startsWith("0") && value.length != 1) {
        if (value[1] != ".") {
            return value.replace(/^0+(\d)/, "$1");
        }
    }
    return value;
}

// math.js的bignumber add对于六位数以上会出错
export function accAdd(arg1, arg2, arg3) {
    let r1, r2, r3, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    try {
        r3 = arg3.toString().split(".")[1].length;
    } catch (e) {
        r3 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2, r3));
    return (arg1 * m + arg2 * m + arg3 * m) / m;
}
// 减
export function subtract(parameter1, parameter2) {
    // 0.2-0.1
    return math.format(
        math
            .chain(math.bignumber(parameter1))
            .subtract(math.bignumber(parameter2))
            .done()
    );
}
// 乘
export function multiply(parameter1, parameter2) {
    // 0.1*0.2
    return math.format(
        math
            .chain(math.bignumber(parameter1))
            .multiply(math.bignumber(parameter2))
            .done()
    );
}
// 除
export function divide(parameter1, parameter2) {
    //0.1/0.2
    return math.format(
        math
            .chain(math.bignumber(parameter1))
            .divide(math.bignumber(parameter2))
            .done()
    );
}
// 四舍五入
export function sround(num, length) {
    let number = math.round(num, length);
    var s = number.toString();
    var rs = s.indexOf(".");
    if (rs < 0) {
        rs = s.length;
        s += ".";
    }
    while (s.length <= rs + length) {
        s += "0";
    }
    return Number(s);
}

// 數字添加千位符
export function addThousandsSeparator(num) {
    if (isEmpty(num)) {
        return "";
    }
    var decimal = String(num).split(".")[1] || "";
    var tempArr = [];
    var revNumArr = String(num).split(".")[0].split("").reverse();
    for (const i in revNumArr) {
        tempArr.push(revNumArr[i]);
        if ((i + 1) % 3 === 0 && i != revNumArr.length - 1) {
            tempArr.push(",");
        }
    }
    var zs = tempArr.reverse().join("");
    return decimal ? zs + "." + decimal : zs;
}

export function dateFormatByLocale(date, lang, format) {
    if (format === undefined) format = ["D MMMM yyyy", "YYYY年M月DD日"];
    switch (lang) {
        case "tc":
        case "sc":
            return moment(date).tz("Asia/Hong_Kong").format(format[1]);
        case "en":
        default:
            return moment(date).tz("Asia/Hong_Kong").format(format[0]);
    }
}

export function getFullDateDisplay(date, lang) {
    return dateFormatByLocale(date, lang, ["D MMMM yyyy", "YYYY年M月D日"]);
}

export function getConfirmationDateDisplay(date, lang) {
    return dateFormatByLocale(date, lang, ["DD/MM/yyyy", "YYYY年M月DD日"]);
}

export function getConfirmationMonthDisplay(date, lang) {
    return dateFormatByLocale(date, lang, ["MM/yyyy", "YYYY年M月"]);
}

export function getConfirmationDateEnDisplay(date, lang) {
    return dateFormatByLocale(date, lang, ["DD MMM YYYY", "YYYY年M月DD日"]);
}

export function getConfirmationFullDateDisplay(date, lang) {
    return dateFormatByLocale(date, lang, ["DD/MM/yyyy", "YYYY年MM月DD日"]);
}

export function loopThroughObject(target, notation) {
    return notation.split(".").reduce((o, i) => {
        return o[i];
    }, target);
}

function getIamsmartAddrData(iasContent, val) {
    let result = "";
    for (var i = 0; i < val.length; i++) {
        result +=
            val[i].key === "residentialChi09PhaseName" &&
            isNotEmpty(iasContent?.[val?.[i]?.key])
                ? "第"
                : "";
        result += isNotEmpty(iasContent?.[val?.[i]?.key])
            ? iasContent?.[val?.[i]?.key]
            : "";
        result += isEmpty(iasContent?.[val?.[i]?.key])
            ? ""
            : val[i]?.comma && isNotEmpty(iasContent?.[val?.[i + 1]?.key])
            ? ", "
            : val[i].key === "residentialChi02UnitNo" ||
              val[i].key === "residentialChi11BuildingNoFrom"
            ? "號"
            : val[i].key === "residentialChi09PhaseName"
            ? "期"
            : i != val.length - 1 && isNotEmpty(iasContent?.[val?.[i + 1]?.key])
            ? " "
            : "";
    }
    return result;
}

function isHongKong(val) {
    return val === "HK" || val === "KLN" || val === "NT" ? "HK-CN" : val;
}

function getIamsmartAddr(iasContent, type, lang) {
    if (lang == "Eng")
        return (
            (isNotEmpty(iasContent[type + lang + "01" + "UnitDescriptor"])
                ? iasContent[type + lang + "01" + "UnitDescriptor"] + " "
                : "") +
            (isNotEmpty(iasContent[type + lang + "02" + "UnitNo"])
                ? iasContent[type + lang + "02" + "UnitNo"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "03" + "FloorNum"])
                ? iasContent[type + lang + "03" + "FloorNum"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "04" + "FloorDescription"])
                ? iasContent[type + lang + "04" + "FloorDescription"] + " "
                : "") +
            (isNotEmpty(iasContent[type + lang + "05" + "BlockDescriptor"])
                ? iasContent[type + lang + "05" + "BlockDescriptor"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "06" + "BlockNo"])
                ? iasContent[type + lang + "06" + "BlockNo"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "07" + "BuildingName"])
                ? iasContent[type + lang + "07" + "BuildingName"] + " "
                : "") +
            (isNotEmpty(iasContent[type + lang + "08" + "EstateName"])
                ? iasContent[type + lang + "08" + "EstateName"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "09" + "PhaseName"])
                ? iasContent[type + lang + "09" + "PhaseName"] + " "
                : "") +
            (isNotEmpty(iasContent[type + lang + "10" + "PhaseNo"])
                ? isNotEmpty(iasContent[type + lang + "10" + "PhaseNo"]) + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "11" + "BuildingNoFrom"])
                ? iasContent[type + lang + "11" + "BuildingNoFrom"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "12" + "StreetName"])
                ? iasContent[type + lang + "12" + "StreetName"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "13" + "Sub-district"])
                ? iasContent[type + lang + "13" + "Sub-district"] + ", "
                : "") +
            (isNotEmpty(iasContent[type + lang + "15" + "Region"])
                ? iasContent[type + lang + "15" + "Region"] === "KLN"
                    ? "Kowloon"
                    : iasContent[type + lang + "15" + "Region"] === "HK"
                    ? "Hong Kong"
                    : iasContent[type + lang + "15" + "Region"] === "NT"
                    ? "New Territories"
                    : ""
                : "")
        );
    else {
        return (
            iasContent[type + lang + "13Sub-district"] +
            iasContent[type + lang + "12StreetName"] +
            iasContent[type + lang + "11BuildingNoFrom"] +
            iasContent[type + lang + "10PhaseNo"] +
            iasContent[type + lang + "09PhaseName"] +
            iasContent[type + lang + "08EstateName"] +
            iasContent[type + lang + "07BuildingName"] +
            iasContent[type + lang + "06BlockNo"] +
            iasContent[type + lang + "05BlockDescriptor"] +
            iasContent[type + lang + "04FloorDescription"] +
            iasContent[type + lang + "03FloorNum"] +
            iasContent[type + lang + "02UnitNo"] +
            iasContent[type + lang + "01UnitDescriptor"]
        );
    }
}

export function stringToMonth(month) {
    const monthList = [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dev",
    ];
    const monthNum = parseInt(month);

    return monthList[monthNum];
}

export function mapIamsmart(iasFieldMap, iasContent, setValue) {
    const tempMap = iasFieldMap;
    for (const [key, notation] of Object.entries(iasFieldMap)) {
        if (
            notation.val == "englishSurname" ||
            notation.val == "englishOtherName"
        ) {
            if (isEmpty(iasContent["enName"])) {
                tempMap[key].isChanged = true;
            } else {
                setValue(
                    key,
                    separateName(notation.iasName, iasContent["enName"])
                );
                setValue(key, separateName(notation.val, iasContent["enName"]));
                tempMap[key].isChanged = false;
            }
        } else if (
            notation.val == "chineseSurname" ||
            notation.val == "chineseOtherName"
        ) {
            if (isEmpty(iasContent["chName"])) {
                tempMap[key].isChanged = true;
            } else {
                setValue(
                    key,
                    separateName(notation.iasName, iasContent["chName"])
                );
                setValue(key, separateName(notation.val, iasContent["chName"]));
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "pureMobileNumber") {
            if (isEmpty(iasContent["mobileNumber"])) {
                tempMap[key].isChanged = true;
            } else {
                setValue(key, iasContent["mobileNumber"]);
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "mobileNumber") {
            if (
                iasContent["mobileNumber"] == "" &&
                iasContent["mobileNumberCountryCode"] == ""
            ) {
                tempMap[key].isChanged = true;
            } else {
                setValue(
                    key,
                    `${iasContent["mobileNumberCountryCode"]}-${iasContent["mobileNumber"]}`
                );
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "homeTelNumber") {
            if (notation.type === "pure") {
                setValue(key, iasContent["homeTelNumber"]);
            } else {
                const result =
                    isNotEmpty(iasContent["homeTelNumberCountryCode"]) &&
                    isNotEmpty(iasContent["homeTelNumber"])
                        ? iasContent["homeTelNumberCountryCode"] +
                          "-" +
                          iasContent["homeTelNumber"]
                        : iasContent["homeTelNumber"];
                setValue(key, result);
            }

            if (iasContent["homeTelNumber"] == "")
                tempMap[key].isChanged = true;
            else tempMap[key].isChanged = false;
        } else if (notation.iasName == "officeTelNumber") {
            setValue(
                key,
                iasContent["officeTelNumberCountryCode"] +
                    "-" +
                    iasContent["officeTelNumber"]
            );
            if (
                iasContent["officeTelNumber"] == "" &&
                iasContent["officeTelNumberCountryCode"] == ""
            )
                tempMap[key].isChanged = true;
            else tempMap[key].isChanged = false;
        } else if (notation.iasName == "residentialAddress") {
            let lang = notation.lang == "Chi" ? "Chi" : "Eng";
            if (tempMap[key].val) {
                let val = [];
                let optionMap = {};
                let optionKey = "";
                if (tempMap[key]?.options instanceof Object) {
                    Object.keys(tempMap[key]?.options)?.map((districKey) => {
                        optionMap = {
                            ...optionMap,
                            ...tempMap[key]?.options?.[districKey],
                        };
                    });
                }
                switch (tempMap[key].val) {
                    case "flat":
                        val =
                            notation.lang == "Chi"
                                ? [
                                      {
                                          key: `residential${lang}02UnitNo`,
                                      },
                                      {
                                          key: `residential${lang}01UnitDescriptor`,
                                      },
                                  ]
                                : [
                                      {
                                          key: `residential${lang}01UnitDescriptor`,
                                      },
                                      {
                                          key: `residential${lang}02UnitNo`,
                                      },
                                  ];
                        break;
                    case "floor":
                        val =
                            notation.lang == "Chi"
                                ? [
                                      {
                                          key: `residential${lang}04FloorDescription`,
                                      },
                                      {
                                          key: `residential${lang}03FloorNum`,
                                          comma: true,
                                      },
                                  ]
                                : [
                                      {
                                          key: `residential${lang}03FloorNum`,
                                          comma: true,
                                      },
                                      {
                                          key: `residential${lang}04FloorDescription`,
                                      },
                                  ];
                        break;
                    case "block":
                        val =
                            notation.lang == "Chi"
                                ? [
                                      {
                                          key: `residential${lang}07BuildingName`,
                                      },
                                      {
                                          key: `residential${lang}06BlockNo`,
                                      },
                                      {
                                          key: `residential${lang}05BlockDescriptor`,
                                      },
                                  ]
                                : [
                                      {
                                          key: `residential${lang}05BlockDescriptor`,
                                      },
                                      {
                                          key: `residential${lang}06BlockNo`,
                                          comma: true,
                                      },
                                      {
                                          key: `residential${lang}07BuildingName`,
                                      },
                                  ];
                        break;
                    case "estate":
                        val = [
                            {
                                key: `residential${lang}08EstateName`,
                            },
                            { key: `residential${lang}09PhaseName` },
                        ];
                        break;
                    case "road":
                        val =
                            notation.lang == "Chi"
                                ? [
                                      {
                                          key: `residential${lang}12StreetName`,
                                      },
                                      {
                                          key: `residential${lang}11BuildingNoFrom`,
                                      },
                                      { key: `residential${lang}10PhaseNo` },
                                  ]
                                : [
                                      {
                                          key: `residential${lang}10PhaseNo`,
                                          comma: true,
                                      },
                                      {
                                          key: `residential${lang}11BuildingNoFrom`,
                                          comma: true,
                                      },
                                      { key: `residential${lang}12StreetName` },
                                  ];
                        break;
                    case "country":
                        optionKey = Object.keys(optionMap)?.find((district) => {
                            const districtResult =
                                district === "HK-CN" && notation.lang === "Eng"
                                    ? district
                                    : optionMap[district];
                            return (
                                districtResult?.toUpperCase() ===
                                isHongKong(
                                    iasContent?.[`residential${lang}15Region`]
                                )?.toUpperCase()
                            );
                        });
                        if (isNotEmpty(optionKey)) {
                            iasContent[`residential${lang}15Region`] =
                                optionKey;
                        } else {
                            iasContent[`residential${lang}15Region`] = "";
                        }
                        val = [{ key: `residential${lang}15Region` }];
                        break;
                    case "district":
                        val = [{ key: `residential${lang}14DcDistrict` }];
                        break;
                    case "sub-district":
                        optionKey = Object.keys(optionMap)?.find(
                            (district) =>
                                optionMap[district]?.toUpperCase() ===
                                iasContent?.[
                                    `residential${lang}13Sub-district`
                                ]?.toUpperCase()
                        );
                        if (isNotEmpty(optionKey)) {
                            iasContent[`residential${lang}13Sub-district`] =
                                optionKey;
                        } else {
                            iasContent[`residential${lang}13Sub-district`] = "";
                        }
                        val = [{ key: `residential${lang}13Sub-district` }];
                        break;
                }
                setValue(key, getIamsmartAddrData(iasContent, val));
                tempMap[key].isChanged = false;
                if (isEmpty(getIamsmartAddrData(iasContent, val))) {
                    tempMap[key].isChanged = true;
                    setValue(key, "");
                }
            } else {
                if (notation.lang == "Chi") {
                    setValue(
                        key,
                        getIamsmartAddr(iasContent, "residential", "Chi")
                    );
                    tempMap[key].isChanged = false;
                    if (isEmpty(iasContent["residentialChi07BuildingName"])) {
                        tempMap[key].isChanged = true;
                        setValue(key, "");
                    }
                } else {
                    setValue(
                        key,
                        getIamsmartAddr(iasContent, "residential", "Eng")
                    );
                    tempMap[key].isChanged = false;
                    if (isEmpty(iasContent["residentialEng07BuildingName"])) {
                        tempMap[key].isChanged = true;
                        setValue(key, "");
                    }
                }
            }
        } else if (notation.iasName == "postalAddress") {
            if (notation.lang == "Chi") {
                setValue(key, getIamsmartAddr(iasContent, "postal", "Chi"));
                tempMap[key].isChanged = false;
                if (isEmpty(iasContent["postalChi07BuildingName"])) {
                    tempMap[key].isChanged = true;
                    setValue(key, "");
                }
            } else {
                setValue(key, getIamsmartAddr(iasContent, "postal", "Eng"));
                tempMap[key].isChanged = false;
                if (isEmpty(iasContent["postalEng07BuildingName"])) {
                    tempMap[key].isChanged = true;
                    setValue(key, "");
                }
            }
        } else if (notation.iasName == "idNo") {
            var HKID =
                iasContent["idNo"] + "(" + iasContent["checkDigit"] + ")";
            setValue(key, HKID);
            if (iasContent["idNo"] == "" && iasContent["checkDigit"] == "")
                tempMap[key].isChanged = true;
            else tempMap[key].isChanged = false;
        } else if (notation.iasName == "birthDate") {
            if (notation?.section === "month") {
                const stringMonth = iasContent["birthDate"]?.slice(4, 6);
                setValue(key, stringToMonth(stringMonth));
            } else if (notation?.section === "year") {
                setValue(key, iasContent["birthDate"]?.slice(0, 4));
            } else {
                setValue(key, iasContent["birthDate"]);
            }
            if (isEmpty(iasContent["birthDate"])) {
                tempMap[key].isChanged = true;
                setValue(key, "");
            } else {
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "prefix") {
            if (isNotEmpty(notation.options)) {
                const keyArr = Object.keys(notation.options);
                if (
                    isNotEmpty(iasContent["prefix"]) &&
                    keyArr.findIndex((key) => key === iasContent["prefix"]) > -1
                ) {
                    setValue(key, iasContent["prefix"]);
                    tempMap[key].isChanged = false;
                } else {
                    tempMap[key].isChanged = true;
                    setValue(key, "");
                }
            } else {
                if (isNotEmpty(iasContent["prefix"])) {
                    setValue(key, iasContent["prefix"]);
                    tempMap[key].isChanged = false;
                } else {
                    tempMap[key].isChanged = true;
                    setValue(key, "");
                }
            }
        } else if (key == "formFilled") {
            tempMap.formFilled = true;
        } else {
            setValue(key, loopThroughObject(iasContent, notation.iasName));
            if (isEmpty(loopThroughObject(iasContent, notation.iasName)))
                tempMap[key].isChanged = true;
            else tempMap[key].isChanged = false;
        }
    }
    //useCallback(() => setIasFieldMap(tempMap), []);
    //setIasFieldMap(tempMap);
    console.log("map", tempMap, iasFieldMap);
    return tempMap;
}

export function mapIamsmartV20(
    iasFieldMap,
    iasContent,
    setValue,
    otherParamsMap
) {
    const tempMap = iasFieldMap;
    let addressSplited = iasFieldMap["addressSplited"];
    let residentialAddressObjEmptyFlag =
        iasContent["residentialAddressObjEmptyFlag"];
    for (const [key, notation] of Object.entries(iasFieldMap)) {
        if (
            notation.val == "englishSurname" ||
            notation.val == "englishOtherName" ||
            notation.val == "englishName" ||
            notation.val == "englishNameTwo"
        ) {
            if (isEmpty(iasContent["enName"])) {
                tempMap[key].isChanged = true;
            } else {
                setValue(key, separateName(notation.val, iasContent["enName"]));
                tempMap[key].isChanged = false;
            }
        } else if (
            notation.val == "chineseSurname" ||
            notation.val == "chineseOtherName"
        ) {
            if (isEmpty(iasContent["chName"])) {
                tempMap[key].isChanged = true;
            } else {
                setValue(key, separateName(notation.val, iasContent["chName"]));
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "pureMobileNumber") {
            if (isObjectEmpty(iasContent["mobileNumber"])) {
                tempMap[key].isChanged = true;
            } else {
                setValue(key, iasContent["mobileNumber"]);
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "mobileNumber") {
            if (
                isObjectEmpty(iasContent["mobileNumber"]) ||
                isObjectEmpty(iasContent["mobileNumberCountryCode"])
            ) {
                tempMap[key].isChanged = true;
            } else {
                setValue(
                    key,
                    `${iasContent["mobileNumberCountryCode"]}-${iasContent["mobileNumber"]}`
                );
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "homeTelNumber") {
            if (
                isObjectEmpty(iasContent["homeTelNumber"]) ||
                isObjectEmpty(iasContent["homeTelNumberCountryCode"])
            ) {
                tempMap[key].isChanged = true;
            } else {
                if (notation.type === "pure") {
                    setValue(key, iasContent["homeTelNumber"]);
                } else {
                    setValue(
                        key,
                        iasContent["homeTelNumberCountryCode"] +
                            "-" +
                            iasContent["homeTelNumber"]
                    );
                }
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "officeTelNumber") {
            if (
                isObjectEmpty(iasContent["officeTelNumber"]) ||
                isObjectEmpty(iasContent["officeTelNumberCountryCode"])
            ) {
                tempMap[key].isChanged = true;
            } else {
                setValue(
                    key,
                    iasContent["officeTelNumberCountryCode"] +
                        "-" +
                        iasContent["officeTelNumber"]
                );
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "residentialAddress") {
            if (
                isNotEmpty(addressSplited) &&
                addressSplited &&
                isNotEmpty(notation.val)
            ) {
                if (residentialAddressObjEmptyFlag === false) {
                    if (notation.val === "country") {
                        let optionMap = {};
                        let optionKey = "";
                        if (tempMap[key]?.options instanceof Object) {
                            Object.keys(tempMap[key]?.options)?.map(
                                (districKey) => {
                                    optionMap = {
                                        ...optionMap,
                                        ...tempMap[key]?.options?.[districKey],
                                    };
                                }
                            );
                        }
                        optionKey = Object.keys(optionMap)?.find(
                            (district) =>
                                optionMap[district]?.toUpperCase() ===
                                iasContent?.["country"]?.toUpperCase()
                        );
                        if (isNotEmpty(optionKey)) {
                            tempMap[key].isChanged = false;
                            setValue(key, optionKey);
                        } else {
                            tempMap[key].isChanged = true;
                        }
                    } else if (notation.val === "sub-district") {
                        let optionMap = {};
                        let optionKey = "";
                        if (tempMap[key]?.options instanceof Object) {
                            Object.keys(tempMap[key]?.options)?.map(
                                (districKey) => {
                                    optionMap = {
                                        ...optionMap,
                                        ...tempMap[key]?.options?.[districKey],
                                    };
                                }
                            );
                        }
                        optionKey = Object.keys(optionMap)?.find(
                            (district) =>
                                optionMap[district]?.toUpperCase() ===
                                iasContent?.["sub-district"]?.toUpperCase()
                        );
                        if (isNotEmpty(optionKey)) {
                            tempMap[key].isChanged = false;
                            setValue(key, optionKey);
                        } else {
                            tempMap[key].isChanged = true;
                        }
                    } else {
                        setValue(
                            key,
                            loopThroughObject(iasContent, notation.val)
                        );
                        if (
                            isEmpty(loopThroughObject(iasContent, notation.val))
                        )
                            tempMap[key].isChanged = true;
                        else tempMap[key].isChanged = false;
                    }
                } else {
                    tempMap[key].isChanged = true;
                }
            } else {
                // 检查 map 中 residentialAddress 是否同时需要中英文
                let needDualLanguage = false;
                let hasChiAddress = false;
                let hasEngAddress = false;
                Object.keys(tempMap).forEach((mapKey) => {
                    if (tempMap[mapKey]?.iasName === "residentialAddress") {
                        if (tempMap[mapKey]?.lang === "Chi")
                            hasChiAddress = true;
                        if (tempMap[mapKey]?.lang === "Eng")
                            hasEngAddress = true;
                    }
                });
                needDualLanguage = hasChiAddress && hasEngAddress;

                if (needDualLanguage) {
                    // 双语模式：根据字段的 lang 精确匹配
                    if (isObjectNotEmpty(tempMap[key]?.lang)) {
                        if (tempMap[key]?.lang === "Chi") {
                            if (
                                isObjectNotEmpty(
                                    iasContent["chiPremisesAddress"]
                                )
                            ) {
                                setValue(key, iasContent["chiPremisesAddress"]);
                                tempMap[key].isChanged = false;
                            } else if (
                                isObjectNotEmpty(
                                    iasContent["chiFreeFormatAddress"]
                                )
                            ) {
                                setValue(
                                    key,
                                    iasContent["chiFreeFormatAddress"]
                                );
                                tempMap[key].isChanged = false;
                            } else if (
                                isObjectNotEmpty(
                                    iasContent["chiPostBoxAddress"]
                                )
                            ) {
                                setValue(key, iasContent["chiPostBoxAddress"]);
                                tempMap[key].isChanged = false;
                            } else {
                                tempMap[key].isChanged = true;
                            }
                        } else if (tempMap[key]?.lang === "Eng") {
                            if (
                                isObjectNotEmpty(
                                    iasContent["engPremisesAddress"]
                                )
                            ) {
                                setValue(key, iasContent["engPremisesAddress"]);
                                tempMap[key].isChanged = false;
                            } else if (
                                isObjectNotEmpty(
                                    iasContent["engFreeFormatAddress"]
                                )
                            ) {
                                setValue(
                                    key,
                                    iasContent["engFreeFormatAddress"]
                                );
                                tempMap[key].isChanged = false;
                            } else if (
                                isObjectNotEmpty(
                                    iasContent["engPostBoxAddress"]
                                )
                            ) {
                                setValue(key, iasContent["engPostBoxAddress"]);
                                tempMap[key].isChanged = false;
                            } else {
                                tempMap[key].isChanged = true;
                            }
                        } else {
                            tempMap[key].isChanged = true;
                        }
                    } else {
                        tempMap[key].isChanged = true;
                    }
                } else {
                    // 单语模式：保持原有逻辑不变
                    if (isObjectNotEmpty(iasContent["chiPremisesAddress"])) {
                        if (isObjectNotEmpty(tempMap[key]?.lang)) {
                            //如设置了这个值才检查，没有就不检查(如form27)
                            if (tempMap[key]?.lang === "Chi") {
                                setValue(key, iasContent["chiPremisesAddress"]);
                                tempMap[key].isChanged = false;
                            } else {
                                tempMap[key].isChanged = true;
                            }
                        } else {
                            setValue(key, iasContent["chiPremisesAddress"]);
                            tempMap[key].isChanged = false;
                        }
                    } else if (
                        isObjectNotEmpty(iasContent["engPremisesAddress"])
                    ) {
                        if (isObjectNotEmpty(tempMap[key]?.lang)) {
                            //如设置了这个值才检查，没有就不检查(如form27)
                            if (tempMap[key]?.lang === "Eng") {
                                setValue(key, iasContent["engPremisesAddress"]);
                                tempMap[key].isChanged = false;
                            } else {
                                tempMap[key].isChanged = true;
                            }
                        } else {
                            setValue(key, iasContent["engPremisesAddress"]);
                            tempMap[key].isChanged = false;
                        }
                    } else if (
                        isObjectNotEmpty(iasContent["chiFreeFormatAddress"])
                    ) {
                        setValue(key, iasContent["chiFreeFormatAddress"]);
                        tempMap[key].isChanged = false;
                    } else if (
                        isObjectNotEmpty(iasContent["engFreeFormatAddress"])
                    ) {
                        setValue(key, iasContent["engFreeFormatAddress"]);
                        tempMap[key].isChanged = false;
                    } else if (
                        isObjectNotEmpty(iasContent["chiPostBoxAddress"])
                    ) {
                        setValue(key, iasContent["chiPostBoxAddress"]);
                        tempMap[key].isChanged = false;
                    } else if (
                        isObjectNotEmpty(iasContent["engPostBoxAddress"])
                    ) {
                        setValue(key, iasContent["engPostBoxAddress"]);
                        tempMap[key].isChanged = false;
                    } else {
                        tempMap[key].isChanged = true;
                        //setValue(key, "");
                    }
                }
            }
        } else if (notation.iasName == "postalAddress") {
            if (isObjectNotEmpty(iasContent["chiPremisesAddressPostal"])) {
                // setValue(key, iasContent["chiPremisesAddressPostal"]);
                // tempMap[key].isChanged = false;
                if (isObjectNotEmpty(tempMap[key]?.lang)) {
                    //如设置了这个值才检查，没有就不检查
                    if (tempMap[key]?.lang === "Chi") {
                        setValue(key, iasContent["chiPremisesAddressPostal"]);
                        tempMap[key].isChanged = false;
                    } else {
                        tempMap[key].isChanged = true;
                    }
                } else {
                    setValue(key, iasContent["chiPremisesAddressPostal"]);
                    tempMap[key].isChanged = false;
                }
            } else if (
                isObjectNotEmpty(iasContent["engPremisesAddressPostal"])
            ) {
                // setValue(key, iasContent["engPremisesAddressPostal"]);
                // tempMap[key].isChanged = false;
                if (isObjectNotEmpty(tempMap[key]?.lang)) {
                    //如设置了这个值才检查，没有就不检查
                    if (tempMap[key]?.lang === "Eng") {
                        setValue(key, iasContent["engPremisesAddressPostal"]);
                        tempMap[key].isChanged = false;
                    } else {
                        tempMap[key].isChanged = true;
                    }
                } else {
                    setValue(key, iasContent["engPremisesAddressPostal"]);
                    tempMap[key].isChanged = false;
                }
            } else if (
                isObjectNotEmpty(iasContent["chiFreeFormatAddressPostal"])
            ) {
                setValue(key, iasContent["chiFreeFormatAddressPostal"]);
                tempMap[key].isChanged = false;
            } else if (
                isObjectNotEmpty(iasContent["engFreeFormatAddressPostal"])
            ) {
                setValue(key, iasContent["engFreeFormatAddressPostal"]);
                tempMap[key].isChanged = false;
            } else if (
                isObjectNotEmpty(iasContent["chiPostBoxAddressPostal"])
            ) {
                setValue(key, iasContent["chiPostBoxAddressPostal"]);
                tempMap[key].isChanged = false;
            } else if (
                isObjectNotEmpty(iasContent["engPostBoxAddressPostal"])
            ) {
                setValue(key, iasContent["engPostBoxAddressPostal"]);
                tempMap[key].isChanged = false;
            } else {
                tempMap[key].isChanged = true;
                //setValue(key, "");
            }
        } else if (notation.iasName == "idNo") {
            var HKID =
                iasContent["idNo"] + "(" + iasContent["checkDigit"] + ")";
            setValue(key, HKID);
            if (iasContent["idNo"] == "" && iasContent["checkDigit"] == "")
                tempMap[key].isChange = true;
            else tempMap[key].isChanged = false;
        } else if (notation.iasName == "birthDate") {
            if (notation?.section === "month") {
                const stringMonth = iasContent["birthDate"]?.slice(4, 6);
                setValue(key, stringToMonth(stringMonth));
            } else if (notation?.section === "year") {
                setValue(key, iasContent["birthDate"]?.slice(0, 4));
            } else {
                setValue(key, iasContent["birthDate"]);
            }
            if (isEmpty(iasContent["birthDate"])) {
                tempMap[key].isChanged = true;
                setValue(key, "");
            } else {
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "gender") {
            if (isEmpty(iasContent["gender"])) {
                tempMap[key].isChanged = true;
            } else {
                let sex = iasContent["gender"];
                if (sex === "F") {
                    if (tempMap[key].val === "special") {
                        //主要是兼容Form27, from96,from101
                        setValue(key, iasContent["gender"]);
                    } else {
                        setValue(key, "female");
                    }
                } else if (sex === "M") {
                    if (tempMap[key].val === "special") {
                        //主要是兼容Form27, from96,from101
                        setValue(key, iasContent["gender"]);
                    } else {
                        setValue(key, "male");
                    }
                }
                tempMap[key].isChanged = false;
            }
        } else if (notation.iasName == "prefix") {
            if (isEmpty(iasContent["prefix"])) {
                tempMap[key].isChanged = true;
            } else {
                if (
                    isObjectNotEmpty(otherParamsMap) &&
                    isObjectNotEmpty(otherParamsMap["titleOption"])
                ) {
                    let titleOption = otherParamsMap["titleOption"];
                    let optionsArray = Object.keys(titleOption);
                    console.log(
                        "in prefix titleOption===" + JSON.stringify(titleOption)
                    );
                    let title = iasContent["prefix"];
                    if (!optionsArray.includes(title)) {
                        tempMap[key].isChanged = true;
                    } else {
                        setValue(key, iasContent["prefix"]);
                        tempMap[key].isChanged = false;
                    }
                } else {
                    setValue(key, iasContent["prefix"]);
                    tempMap[key].isChanged = false;
                }
            }
        } else if (key == "formFilled") {
            tempMap.formFilled = true;
        } else if (key == "addressSplited" || key == "formLang") {
            console.log("addressSplited=" + addressSplited);
        } else {
            // setValue(key, loopThroughObject(iasContent, notation.iasName));
            // if (isEmpty(loopThroughObject(iasContent, notation.iasName)))
            //     tempMap[key].isChanged = true;
            // else tempMap[key].isChanged = false;
            if (isEmpty(loopThroughObject(iasContent, notation.iasName))) {
                tempMap[key].isChanged = true;
            } else {
                setValue(key, loopThroughObject(iasContent, notation.iasName));
                tempMap[key].isChanged = false;
            }
        }
    }
    //useCallback(() => setIasFieldMap(tempMap), []);
    //setIasFieldMap(tempMap);
    console.log("tempMap========" + JSON.stringify(tempMap));
    return tempMap;
}

export function mapToStringIamsmart(iasFieldMap) {
    let mapString = "";
    let fieldSet = new Set();
    for (const [key, value] of Object.entries(iasFieldMap)) {
        console.log(`${key}: ${value}`);
        if (
            key != "formFilled" &&
            key != "addressSplited" &&
            key != "formLang"
        ) {
            fieldSet.add(value.iasName);
        }
    }
    fieldSet.forEach((field) => {
        let fieldName = field;
        if (field === "pureMobileNumber") {
            fieldName = "mobileNumber";
        }
        if (mapString == "") {
            mapString = mapString.concat(fieldName);
        } else {
            mapString = mapString.concat(",", fieldName);
        }
    });
    return mapString;
}

export function getIamsmartAppUrl(ticketId, func) {
    const scheme = `${Config.SCHEME}`;

    return scheme + "://" + func + "?ticketID=" + ticketId;
}

export function getUserAgent() {
    let mobileSystem = "";
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        mobileSystem = "Windows Phone";
    }
    if (/android/i.test(userAgent)) {
        mobileSystem = "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        mobileSystem = "iOS";
    }
    //No need special to check Firefox, because firefox not equal with mobile
    /*if (/Firefox/i.test(userAgent)) {
        mobileSystem = "Firefox";
    }*/

    return mobileSystem;
}

export function isIOS() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export function isSafari() {
    return (
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(
            !window["safari"] ||
                (typeof safari !== "undefined" &&
                    window["safari"].pushNotification)
        )
    );
}

export function parseReferenceNumber(referenceNumber) {
    return {
        formId: referenceNumber.slice(0, 7),
        id: parseIntFormRef(referenceNumber),
    };
}

export function parseIntFormId(formId) {
    return parseIntDecimal(formId?.slice(4, 7));
}

export function parseIntFormRef(referenceNumber) {
    return parseIntDecimal(referenceNumber?.slice(7));
}

export function parseIntDecimal(str) {
    return parseInt(str, 10);
}

export function intToformId(id) {
    return `${id}`.padStart(7, "Form000");
}

export function getLangCode(lang) {
    switch (lang) {
        case "tc":
            return "Cht";
        case "sc":
            return "Chs";
        case "en":
        default:
            return "Eng";
    }
}

export function exitEdit(dispatch) {
    dispatch(setCurrentStep("Approval"));
}

export function getTranslation(translationObj, lang) {
    switch (lang) {
        case "tc":
            return translationObj?.tc;
        case "sc":
            return translationObj?.sc;
        case "en":
        default:
            return translationObj?.en;
    }
}

export function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    //Old Code
    //write the ArrayBuffer to a blob, and you're done
    //var bb = new BlobBuilder();
    //bb.append(ab);
    //return bb.getBlob(mimeString);

    //New Code
    return new Blob([ab], { type: mimeString });
}
export function getIsReleasedForm(formId) {
    return (
        isObjectEmpty(Config?.RELEASE_FORM_ARRAY) ||
        Config?.RELEASE_FORM_ARRAY.includes(formId)
    );
}
export function getIsPasswordProtectedForm(formId) {
    return Config?.PASSWORD_GUARD_ARRAY.includes(formId);
}
export function getHasMultiSubmitLayer(formId, formStatus, skipMultiSubmit) {
    return (
        (Constant?.SubmitLayer1.includes(formId) &&
            formStatus === 1 &&
            !skipMultiSubmit.includes("formA")) ||
        (Constant?.SubmitLayer2.includes(formId) &&
            formStatus === 3 &&
            !skipMultiSubmit.includes("formB")) ||
        (Constant?.SubmitLayer3.includes(formId) &&
            formStatus === 5 &&
            !skipMultiSubmit.includes("formC")) ||
        (Constant?.SubmitLayer4.includes(formId) &&
            formStatus === 7 &&
            !skipMultiSubmit.includes("formD")) ||
        (Constant?.SubmitLayer5.includes(formId) &&
            formStatus === 9 &&
            !skipMultiSubmit.includes("formE"))
    );
}
export function getIspreviewPDFTooltipForm(formId) {
    return Constant?.previewPDFTooltipList.includes(formId);
}
export function getIsSpecialStylePICSForm(formId) {
    return Constant?.specialStylePICSFormList.includes(formId);
}
export function getIsApproverSaveForm(formId) {
    return Constant?.approverSaveFormList.includes(formId);
}
export function getIsExceedingDeadlineForm(formId) {
    return Constant?.exceedingDeadlineFormList.includes(formId);
}
export function getIsSubmitEditedButtionForm(formId) {
    return Constant?.submitEditedFormlist.includes(formId);
}
export function getIsDownloadAttachmentForm(formId) {
    return Constant?.downloadAttachmentForm.includes(formId);
}
export function getIsHideSearchPageRoles(role) {
    return Constant?.hideSearchPageRoles.includes(role);
}
export function getAdvSearchFeilds(formId) {
    if (isNotEmpty(Constant?.advSearchFormField?.[formId])) {
        return Constant?.advSearchFormField?.[formId];
    } else {
        return [];
    }
}
export function getAdvSearchResultOffset(formId) {
    return isNotEmpty(Constant?.advSearchResultOffset?.[formId])
        ? Constant?.advSearchResultOffset?.[formId]
        : Constant?.advSearchResultOffset?.Default;
}
export function getIsMultiSubmitEmpty(formStatus, fieldValues) {
    switch (formStatus) {
        case 1:
            return isEmpty(fieldValues.FormA);
        case 3:
            return isEmpty(fieldValues.FormB);
        case 5:
            return isEmpty(fieldValues.FormC);
        case 7:
            return isEmpty(fieldValues.FormD);
        case 9:
            return isEmpty(fieldValues.FormE);
        default:
            return false;
    }
}
export function getIsInApplication(formStatus) {
    return formStatus === 0 || formStatus === -1;
}

export function cloFieldMapping(clo, map) {
    var obj = {};
    Object.entries(map).forEach(([fieldName, fieldValue]) => {
        let isSchoolHead = clo?.school_head == "Y";
        let isSupervisor = clo?.supervisor == "Y";
        switch (fieldValue) {
            case "title":
                fieldValue = ""; // TODO: backend no such value
                break;
            case "role":
                if (isSchoolHead) {
                    fieldValue = "schoolHead";
                } else if (isSupervisor) {
                    fieldValue = "supervisor";
                } else {
                    fieldValue = "";
                }
                break;
            case "enPost":
                if (isSchoolHead) {
                    fieldValue = "School Head";
                } else if (isSupervisor) {
                    fieldValue = "Supervisor";
                } else {
                    fieldValue = "";
                }
                break;
            case "tcPost":
            case "scPost":
                if (isSchoolHead) {
                    fieldValue = "校長";
                } else if (isSupervisor) {
                    fieldValue = "校監";
                } else {
                    fieldValue = "";
                }
                break;

            case "enName":
                fieldValue = clo?.eng_name;
                break;
            case "tcName":
            case "scName":
                fieldValue = clo?.chi_name;
                break;
            case "enSchoolHead":
                if (isSchoolHead) {
                    fieldValue = clo?.eng_name;
                } else {
                    fieldValue = "";
                }
                break;
            case "tcSchoolHead":
            case "scSchoolHead":
                if (isSchoolHead) {
                    fieldValue = isNotEmpty(clo?.chi_name)
                        ? clo?.chi_name
                        : clo?.eng_name;
                } else {
                    fieldValue = "";
                }
                break;
            case "enSupervisor":
                if (isSupervisor) {
                    fieldValue = clo?.eng_name;
                } else {
                    fieldValue = "";
                }

                break;
            case "tcSupervisor":
            case "scSupervisor":
                if (isSupervisor) {
                    fieldValue = isNotEmpty(clo?.chi_name)
                        ? clo?.chi_name
                        : clo?.eng_name;
                } else {
                    fieldValue = "";
                }
                break;
            case "enSchoolName":
                fieldValue = clo?.schl_eng_name;
                break;
            case "tcSchoolName":
            case "scSchoolName":
                fieldValue = clo?.schl_chi_name;
                break;
            // case "schoolCode":
            //     fieldValue = clo?.treaschlcode_list;
            //     break;

            case "treaSchoolCode":
                fieldValue = clo?.treaschlcode_list?.split("|")[0];
                break;

            // case "enKindergarten":
            //     fieldValue =
            //         clo?.schllevltypeeng_ds === "KINDERGARTEN"
            //             ? clo?.schl_eng_name
            //             : "";
            //     break;
            // case "tcKindergarten":
            // case "scKindergarten":
            //     fieldValue =
            //         clo?.schllevltypeeng_ds === "KINDERGARTEN"
            //             ? clo?.schl_chi_name
            //             : "";
            //     break;
            case "enKindergarten":
                fieldValue = clo?.schl_eng_name;
                break;
            case "tcKindergarten":
            case "scKindergarten":
                fieldValue = clo?.schl_chi_name;
                break;

            case "enChildCareCenter":
                fieldValue =
                    clo?.schllevltypeeng_ds !== "KINDERGARTEN"
                        ? clo?.schl_eng_name
                        : "";
                break;
            case "tcChildCareCenter":
            case "scChildCareCenter":
                fieldValue =
                    clo?.schllevltypeeng_ds !== "KINDERGARTEN"
                        ? clo?.schl_chi_name
                        : "";
                break;

            case "schoolCode":
                fieldValue = clo?.scrn.slice(0, 6);
                break;
            case "scrn":
                fieldValue = clo?.scrn;
                break;
            case "schoolNumber":
                fieldValue = clo?.scrn?.slice(0, 6);
                break;
            case "schoolLevel":
                fieldValue = clo?.schllevltypecode;
                break;
            case "financeType":
                fieldValue = clo?.schlfinance_typecd;
                break;
            case "financeTypeName":
                fieldValue = clo?.schlfinance_tpends.toLowerCase();
                break;
            case "email":
                fieldValue = clo?.email;
                break;
            case "telNo":
                fieldValue = clo?.schltele.replace(/\s+/g, "");
                break;
            case "faxNo":
                fieldValue = clo?.fax_numb;
                break;
            case "globalTel":
                fieldValue = `+852-${clo?.schltele?.trim()}`;
                break;
            case "globalFax":
                fieldValue = `+852-${clo?.fax_numb?.trim()}`;
                break;
            case "enAddress":
                fieldValue = ""; // TODO: backend no such value
                break;
            case "tcAddress":
            case "scAddress":
                fieldValue = ""; // TODO: backend no such value
                break;
            case "enSchoolAddress":
                fieldValue = [
                    clo?.room_eng?.trim(),
                    clo?.flr_eng?.trim(),
                    clo?.bloc_eng?.trim(),
                    clo?.bldg_eng?.trim(),
                    clo?.est_eng?.trim(),
                    clo?.st_eng?.trim(),
                    clo?.dist_eng?.trim(),
                    clo?.locna_area_eng.trim(),
                ]
                    .filter(isNotEmpty)
                    .join(", ");
                break;
            case "tcSchoolAddress":
            case "scSchoolAddress":
                fieldValue = [
                    clo?.locna_area_chi.trim(),
                    clo?.dist_chi.trim(),
                    clo?.st_chi.trim(),
                    clo?.est_chi.trim(),
                    clo?.bldg_chi.trim(),
                    clo?.bloc_chi.trim(),
                    clo?.flr_chi.trim(),
                    clo?.room_chi.trim(),
                ]
                    .filter(isNotEmpty)
                    .join(" ");
                break;

            case "schoolType":
                switch (clo?.schllevltypecode) {
                    case "1":
                        fieldValue = "kindergarten";
                        break;
                    case "2":
                    case "s":
                        fieldValue = "primary";
                        break;
                    case "3":
                        fieldValue = "secondary";
                        break;
                    case "4":
                        fieldValue = "special-primary";
                        break;
                    case "5":
                        fieldValue = "special-secondary";
                        break;
                    case "9":
                        fieldValue = "others";
                        break;
                    default:
                        fieldValue = "";
                        break;
                }
                break;
            case "schoolSession":
                switch (clo?.schlsesseng_desc) {
                    case "AM":
                        fieldValue = "am";
                        break;
                    case "PM":
                        fieldValue = "pm";
                        break;
                    case "WHOLE DAY":
                        fieldValue = "wholeDay";
                        break;
                    default:
                        fieldValue = "";
                        break;
                }
                break;

            case "schoolFinanceType":
                switch (clo?.schlfinance_typecd) {
                    case "1":
                        fieldValue = "government";
                        break;
                    case "3":
                        fieldValue = "aided";
                        break;
                    case "4":
                        fieldValue = "caput";
                        break;
                    case "7":
                        fieldValue = "dss";
                        break;
                    default:
                        fieldValue = "";
                        break;
                }
                break;

            case "ssdo":
            case "csdo":
                switch (clo?.ssdopostdesc) {
                    case "SSDO(N)1":
                    case "CSDO(N)":
                        fieldValue = "North";
                        break;
                    case "SSDO(KWT)1":
                    case "CSDO(KWT)":
                        fieldValue = "Kwai_Tsing";
                        break;
                    case "SSDO(SK)1":
                    case "CSDO(SK)":
                        fieldValue = "Sai_Kung";
                        break;
                    case "SSDO(E)1":
                    case "CSDO(E)":
                        fieldValue = "Eastern";
                        break;
                    case "SSDO(TM)1":
                    case "CSDO(TM)":
                        fieldValue = "Tuen_Mun";
                        break;
                    case "SSDO(KC)1":
                    case "CSDO(KC)":
                        fieldValue = "Kowloon_City";
                        break;
                    case "SSDO(KT)1":
                    case "CSDO(KT)":
                        fieldValue = "Kwun_Tong";
                        break;
                    case "SSDO(S)1":
                    case "CSDO(S)":
                        fieldValue = "Southern";
                        break;
                    case "SSDO(YTM)1":
                    case "CSDO(YTM)":
                        fieldValue = "Yau_Tsim_Mong";
                        break;
                    case "SSDO(TW)1":
                    case "CSDO(TW)":
                        fieldValue = "Tsuen_Wan";
                        break;
                    case "SSDO(ST)1":
                    case "CSDO(ST)":
                        fieldValue = "Sha_Tin";
                        break;
                    case "SSDO(SSP)1":
                    case "CSDO(SSP)":
                        fieldValue = "Sham_Shui_Po";
                        break;
                    case "SSDO(TP)1":
                    case "CSDO(TP)":
                        fieldValue = "Tai_Po";
                        break;
                    case "SSDO(WC)1":
                    case "CSDO(WC)":
                        fieldValue = "Wan_Chai";
                        break;
                    case "SSDO(I)1":
                    case "CSDO(I)":
                        fieldValue = "Islands";
                        break;
                    case "SSDO(CW)1":
                    case "CSDO(CW)":
                        fieldValue = "Central_And_Western";
                        break;
                    case "SSDO(YL)1":
                    case "CSDO(YL)":
                        fieldValue = "Yuen_Long";
                        break;
                    case "SSDO(WTS)1":
                    case "CSDO(WTS)":
                        fieldValue = "Wong_Tai_Sin";
                        break;
                    default:
                        fieldValue = clo?.ssdopostdesc;
                        break;
                }
                break;
            case "supervisorOrPrincipal":
                if (isSchoolHead) {
                    fieldValue = "principal";
                } else if (isSupervisor) {
                    fieldValue = "supervisor";
                } else {
                    fieldValue = "";
                }
                break;
            case "locationID":
                fieldValue = clo?.locna_area;
                break;
            case "is_imc":
                fieldValue =
                    clo?.is_imc === "Y"
                        ? "Incorporated"
                        : "ManagementCommittee";
                break;
            default:
                fieldValue = "";
        }
        obj[fieldName] = fieldValue || "";
    });
    return obj;
}

/**
 * 对比两个任意类型的变量是否相等(暂不支持Function)
 * @param {*要对比的两个变量} ab
 */
export const equarComplex = (a, b) => {
    // 判断类型
    const typeA = getObjType(a);
    const typeB = getObjType(b);

    if (typeA !== typeB) {
        return false;
    } else if (typeA === "Base") {
        return a === b;
    } else if (typeA === "Array") {
        if (a.length !== b.length) {
            return false;
        } else {
            // 循环遍历数组的值进行比较
            for (let i = 0; i < a.length; i++) {
                if (!equarComplex(a[i], b[i])) {
                    return false;
                }
            }
            return true;
        }
    } else if (typeA === "Object") {
        if (Object.keys(a).length !== Object.keys(b).length) {
            return false;
        }
        for (var o in a) {
            if (!equarComplex(a[o], b[o])) {
                return false;
            }
        }
        return true;
    } else if (typeA === "Undefined" || typeA === "Null") {
        return true;
    } else if (typeA === "Symbol") {
        if (
            a?.props?.dangerouslySetInnerHTML?.__html ===
                b?.props?.dangerouslySetInnerHTML?.__html ||
            a?.__html === b?.__html
        ) {
            return true;
        } else {
            return false;
        }
    } else {
        if (a instanceof Element && b instanceof Element) {
            var objA = document.createElement("div");
            var objB = document.createElement("div");
            objA.innerHTML = a;
            objB.innerHTML = b;
            return objA.innerHTML === objB.innerHTML;
        } else {
            console.log("Type Error");
            return false;
        }
    }
};

/**
 * 获取变量的类型
 * @param {*要获取类型的变量} obj
 */
export const getObjType = (obj) => {
    const type = Object.prototype.toString.call(obj);
    if (
        obj?.$$typeof != undefined &&
        obj?.$$typeof?.toString() === "Symbol(react.element)"
    ) {
        return "Symbol";
    }
    switch (type) {
        case "[object Array]":
            return "Array";
        case "[object Object]":
            return "Object";
        case "[object Function]":
            return "Function";
        case "[object Undefined]":
            return "Undefined";
        case "[object Null]":
            return "Null";
        case "[object Number]":
        case "[object String]":
        case "[object Boolean]":
            return "Base";
        case "[object Symbol]":
            return "Symbol";
        default:
            return "Error";
    }
};

export const fieldValueToFullJsonObj = (fieldValues, currentStep = "") => {
    let result = {};
    Object.keys(fieldValues).forEach((step) => {
        const stepType = typeof fieldValues[step];
        const stepValue = fieldValues[step];

        if (stepType === "object") {
            if (
                Object.prototype.toString.call(stepValue) !==
                    "[object Array]" &&
                stepValue
            ) {
                result[step] = Object.keys(stepValue);
            } else {
                result[step] = stepValue;
            }
        } else {
            result[step] = stepValue;
        }
    });
    if (isNotEmpty(currentStep)) {
        result.currentStep = currentStep;
    }
    return result;
};

export const fullJsonObjToFieldValue = (fullJsonObject, values) => {
    let result = {};
    const { currentStep, ...fieldMap } = fullJsonObject;
    if (isNotEmpty(currentStep)) {
        result.currentStep = currentStep;
    }
    Object.keys(fieldMap).forEach((stepName) => {
        const stepKey = fullJsonObject[stepName];
        result[stepName] = {};
        if (Object.prototype.toString.call(stepKey) === "[object Array]") {
            stepKey.forEach((field) => {
                result[stepName][field] = values[field];
            });
        } else {
            result[stepName] = stepKey;
        }
    });
    return result;
};

export const checkApplicant = (currentWorkFlow, profile) => {
    if (currentWorkFlow.applicant) {
        let profileUserName = profile.name;
        let applicantUserName = "";
        currentWorkFlow.applicant.forEach((item) => {
            if (item.userName) {
                return (applicantUserName = item.userName);
            }
        });
        if (profileUserName === applicantUserName) {
            return true;
        }
    }
    return false;
};

export const checkApprover = (currentWorkFlow, profile) => {
    if (currentWorkFlow.approver) {
        let profileUserName = profile.name;
        if (isNotEmpty(currentWorkFlow.approver)) {
            return currentWorkFlow.approver.some(
                (item) => profileUserName === item.userName
            );
        }
    }
    return false;
};

export const checkSecApprover = (currentWorkFlow, profile) => {
    if (currentWorkFlow.secApprover) {
        let profileUserName = profile.name;
        if (isNotEmpty(currentWorkFlow.secApprover)) {
            return currentWorkFlow.secApprover.some(
                (item) => profileUserName === item.userName
            );
        }
    }
    return false;
};

export const checkThirdApprover = (currentWorkFlow, profile) => {
    if (currentWorkFlow.thirdApprover) {
        let profileUserName = profile.name;
        if (isNotEmpty(currentWorkFlow.thirdApprover)) {
            return currentWorkFlow.thirdApprover.some(
                (item) => profileUserName === item.userName
            );
        }
    }
    return false;
};

export const checkFourthApprover = (currentWorkFlow, profile) => {
    if (currentWorkFlow.fourthApprover) {
        let profileUserName = profile.name;
        if (isNotEmpty(currentWorkFlow.fourthApprover)) {
            return currentWorkFlow.fourthApprover.some(
                (item) => profileUserName === item.userName
            );
        }
    }
    return false;
};

export const checkReviewer = (currentWorkFlow, profile) => {
    if (currentWorkFlow.reviewer) {
        let profileUserName = profile.name;
        if (isNotEmpty(currentWorkFlow.reviewer)) {
            return currentWorkFlow.reviewer.some(
                (item) => profileUserName === item.userName
            );
        }
    }
    return false;
};

export const getEnquiryTitleParam = (id, titleParamList, language = "en") => {
    let _id = id;
    let formId = id;
    if (typeof id == "number" || isNaN(Number(id)) != true) {
        formId = `Form${id.toString().padStart(3, "0")}`;
    } else if (id && (id.indexOf("form") > -1 || id.indexOf("Form") > -1)) {
        let num = id.substring(4);
        _id = isNaN(num) == false ? Number(num) : id;
    }

    return formId === "Form008" || formId === "Form009"
        ? {
              schoolyear: titleParamList?.schoolyear,
              country: getTranslation(
                  {
                      sc: titleParamList?.countrySc,
                      tc: titleParamList?.countryTc,
                      en: titleParamList?.countryEn,
                  },
                  language
              ),
          }
        : formId === "Form079"
        ? {
              financialYear: getTranslation(
                  {
                      en: titleParamList?.financialYearEn,
                      sc:
                          titleParamList?.financialYearSc ||
                          titleParamList?.financialYearTc,
                      tc: titleParamList?.financialYearTc,
                  },
                  language
              ),
          }
        : formId === "Form043"
        ? {
              date: getTranslation(
                  {
                      en: titleParamList?.asAtDateEn,
                      tc: titleParamList?.asAtDateTc,
                      sc: titleParamList?.asAtDateTc,
                  },
                  language
              ),
          }
        : formId === "Form075"
        ? {
              schoolyear:
                  Number(titleParamList?.formNumber) -
                  1 +
                  "/" +
                  titleParamList?.formNumber?.slice(2),
          }
        : titleParamList;
};

export const getFormTitleParam = (id, titleParamList, language = "en") => {
    let _id = id;
    let formId = id;
    if (typeof id == "number" || isNaN(Number(id)) != true) {
        formId = `Form${id.toString().padStart(3, "0")}`;
    } else if (id && (id.indexOf("form") > -1 || id.indexOf("Form") > -1)) {
        let num = id.substring(4);
        _id = isNaN(num) == false ? Number(num) : id;
    }

    return formId === "Form008" || formId === "Form009"
        ? {
              schoolyear: titleParamList?.[_id]?.schoolyear,
              country: getTranslation(
                  {
                      sc: titleParamList?.[_id]?.countrySc,
                      tc: titleParamList?.[_id]?.countryTc,
                      en: titleParamList?.[_id]?.countryEn,
                  },
                  language
              ),
          }
        : formId === "Form079"
        ? {
              financialYear: getTranslation(
                  {
                      en: titleParamList?.[_id]?.financialYearEn,
                      tc: titleParamList?.[_id]?.financialYearTc,
                  },
                  language
              ),
          }
        : formId === "Form043"
        ? {
              date: getTranslation(
                  {
                      en: titleParamList?.[_id]?.asAtDateEn,
                      tc: titleParamList?.[_id]?.asAtDateTc,
                      sc: titleParamList?.[_id]?.asAtDateTc,
                  },
                  language
              ),
          }
        : formId === "Form075"
        ? {
              schoolyear:
                  Number(titleParamList?.[_id]?.formNumber) -
                  1 +
                  "/" +
                  titleParamList?.[_id]?.formNumber?.slice(2),
          }
        : titleParamList?.[_id];
};

export const handleKgCccSelectArray = (arr, lang = "en") => {
    let cccNameObj = {};
    if (arr.length > 1) {
        arr.forEach((item, index) => {
            if (lang === "en") {
                let curKey = `cccEngName${index}`;
                cccNameObj[curKey] = item.cccEngName ? item.cccEngName : "";
            } else {
                let curKey = `cccChiName${index}`;
                cccNameObj[curKey] = item.cccChiName ? item.cccChiName : "";
            }
        });
    }
    return cccNameObj;
};

export const handleKgCccPrefill = (arr, lang = "en") => {
    let cccName = "";
    if (arr.length <= 1) {
        if (lang === "en") {
            cccName = arr[0]?.cccEngName ? arr[0]?.cccEngName : "";
        } else {
            cccName = arr[0]?.cccChiName ? arr[0]?.cccChiName : "";
        }
    }
    // console.log("cccName", cccName);
    return cccName;
};
export const handleKgCccAddressPrefill = (arr, lang = "en") => {
    let cccAddress = "";
    if (arr.length <= 1) {
        if (lang === "en") {
            cccAddress = arr[0]?.cccEngAddress ? arr[0]?.cccEngAddress : "";
        } else {
            cccAddress = arr[0]?.cccChiAddress ? arr[0]?.cccChiAddress : "";
        }
    }
    // console.log("cccAddress", cccAddress);
    return cccAddress;
};
export const handleKgCccAdressSelectArray = (arr, lang = "en") => {
    let cccAddress = [];
    if (arr.length > 1) {
        arr.forEach((item, index) => {
            if (lang === "en") {
                // let curKey = `cccEngAddress${index}`;
                if (isEmpty(item.cccEngAddress)) {
                    return;
                } else {
                    cccAddress.push(item.cccEngAddress);
                }
            } else {
                if (isEmpty(item.cccChiAddress)) {
                    return;
                } else {
                    cccAddress.push(item.cccChiAddress);
                }
                // let curKey = `cccChiAddress${index}`;
            }
        });
    }
    return cccAddress;
};

// 檢查是否存在複姓
// Check if any compound surname contain in name.
export const isCompoundSurname = (name) => {
    const csListTC = [
        "歐陽",
        "太史",
        "端木",
        "上官",
        "司馬",
        "東方",
        "獨孤",
        "南宮",
        "万俟",
        "聞人",
        "夏侯",
        "諸葛",
        "尉遲",
        "公羊",
        "赫連",
        "澹臺",
        "皇甫",
        "宗政",
        "濮陽",
        "公冶",
        "太叔",
        "申屠",
        "公孫",
        "慕容",
        "仲孫",
        "鍾離",
        "長孫",
        "宇文",
        "司徒",
        "鮮于",
        "司空",
        "閭丘",
        "子車",
        "亓官",
        "司寇",
        "巫馬",
        "公西",
        "顓孫",
        "壤駟",
        "公良",
        "漆雕",
        "樂正",
        "宰父",
        "穀梁",
        "拓跋",
        "夾谷",
        "軒轅",
        "令狐",
        "段乾",
        "百里",
        "呼延",
        "東郭",
        "南門",
        "羊舌",
        "微生",
        "公戶",
        "公玉",
        "公儀",
        "梁丘",
        "公仲",
        "公上",
        "公門",
        "公山",
        "公堅",
        "左丘",
        "公伯",
        "西門",
        "公祖",
        "第五",
        "公乘",
        "貫丘",
        "公皙",
        "南榮",
        "東里",
        "東宮",
        "仲長",
        "子書",
        "子桑",
        "即墨",
        "達奚",
        "褚師",
        "吳銘",
    ];
    const csListSC = [
        "欧阳",
        "太史",
        "端木",
        "上官",
        "司马",
        "东方",
        "独孤",
        "南宫",
        "万俟",
        "闻人",
        "夏侯",
        "诸葛",
        "尉迟",
        "公羊",
        "赫连",
        "澹台",
        "皇甫",
        "宗政",
        "濮阳",
        "公冶",
        "太叔",
        "申屠",
        "公孙",
        "慕容",
        "仲孙",
        "钟离",
        "长孙",
        "宇文",
        "司徒",
        "鲜于",
        "司空",
        "闾丘",
        "子车",
        "亓官",
        "司寇",
        "巫马",
        "公西",
        "颛孙",
        "壤驷",
        "公良",
        "漆雕",
        "乐正",
        "宰父",
        "谷梁",
        "拓跋",
        "夹谷",
        "轩辕",
        "令狐",
        "段干",
        "百里",
        "呼延",
        "东郭",
        "南门",
        "羊舌",
        "微生",
        "公户",
        "公玉",
        "公仪",
        "梁丘",
        "公仲",
        "公上",
        "公门",
        "公山",
        "公坚",
        "左丘",
        "公伯",
        "西门",
        "公祖",
        "第五",
        "公乘",
        "贯丘",
        "公皙",
        "南荣",
        "东里",
        "东宫",
        "仲长",
        "子书",
        "子桑",
        "即墨",
        "达奚",
        "褚师",
        "吴铭",
    ];
    return (
        isNotEmpty(csListTC.find((e) => e === name.slice(0, 2))) ||
        isNotEmpty(csListSC.find((e) => e === name.slice(0, 2)))
    );
};

// 分拆姓名, "targetField" 為期望返回值, "nameValue" 為姓名(全名)
// Separate surname and given name, "targetField" is the expected return, "nameValue" is the full name.
export const separateName = (targetField, nameValue) => {
    // "targetField" options: (1)engSurname (2)engOtherName (3)chiSurname (4)chiOtherName
    if (isEmpty(nameValue)) {
        return "";
    }
    if (targetField === "englishSurname" || targetField === "englishName") {
        return (
            nameValue?.split(",")?.[0] ||
            nameValue?.split("，")?.[0] ||
            nameValue
        );
    }
    if (
        targetField === "englishOtherName" ||
        targetField === "englishNameTwo"
    ) {
        return (
            nameValue?.split(",")?.[1]?.trim() ||
            nameValue?.split("，")?.[1]?.trim() ||
            nameValue
        );
    }
    if (targetField === "chineseSurname") {
        if (isCompoundSurname(nameValue) && nameValue?.length > 2) {
            return nameValue?.slice(0, 2);
        } else {
            return nameValue?.[0];
        }
    }
    if (targetField === "chineseOtherName") {
        if (isCompoundSurname(nameValue) && nameValue?.length > 2) {
            return nameValue?.slice(2);
        } else {
            return nameValue?.slice(1);
        }
    }
};

// 獲取emailTemplate Date數據
export const getEmailTemplateDate = (clo) => {
    let emailTemplate = {
        treasurySchoolCode: "",
        schoolFinanceType: "",
        schoolLvType: "",
    };
    if (isObjectNotEmpty(clo)) {
        emailTemplate.treasurySchoolCode = clo?.treaschlcode_list;
        emailTemplate.schoolFinanceType = clo?.schlfinance_typecd;
        emailTemplate.schoolLvType = clo?.schllevltypecode;
        return emailTemplate;
    }
};

export function getIsEmailTemplateForm(
    formId,
    type = 0,
    lang = "en",
    roleIndex
) {
    console.log("type:", type);
    // console.log("type---", type);
    const defaultTemplateCon = {
        en: "URL: ${url}\nReference Number: ${form_reference_no}\nStatus: ${status}",
        tc: "連結： ${url}\n參考編號： ${form_reference_no}\n狀態： ${status}",
        sc: "连结： ${url}\n参考编号： ${form_reference_no}\n状态： ${status}",
    };
    /*  const defaultTemplateConNew = {
        en: "URL: ${url}\nReference Number: ${form_reference_no}\nStatus: ${status}",
        tc: "連結： ${url}\n參考編號： ${form_reference_no}\n狀態： ${status}",
        sc: "连结： ${url}\n参考编号： ${form_reference_no}\n状态： ${status}",
    }; */
    const applicantTemplateConForm107 = {
        en: "Reference number: ${form_reference_no}",
        tc: "參考編號： ${form_reference_no}",
        sc: "连结参考编号： ${form_reference_no}",
    };
    const defaultTemplateConForm104 = {
        en: "URL: ${url}\nReference Number: ${form_reference_no}\nStatus: ${status}",
        tc: "連結：${url}\n參考編號：${form_reference_no}\n狀態：${status}",
        sc: "连结：${url}\n参考编号：${form_reference_no}\n状态：${status}",
    };
    const twoTemplateCon = {
        en: "School type: ${school_lv_type}\nSchool code: ${treasury_school_code}\nURL: ${url}\nReference Number: ${form_reference_no}\nStatus: ${status}",
        tc: "學校類型： ${school_lv_type}\n學校代碼： ${treasury_school_code}\n連結： ${url}\n參考編號： ${form_reference_no}\n狀態： ${status}",
        sc: "学校类型： ${school_lv_type}\n学校代码： ${treasury_school_code}\n连结： ${url}\n参考编号： ${form_reference_no}\n状态： ${status}",
    };
    if (formId.toString() == "101") {
        defaultTemplateCon.en =
            "This is to acknowledge receipt of your ${submission_type} of application for civil service posts in the Education Bureau (EDB), details as follows:-\n\nReference Number:${form_reference_no}\nPost(s) applied :${job}";
        defaultTemplateCon.tc =
            "確認已收到你${submission_type}的教育局公務員職位申請書，詳情如下:\n\n\n參考編號：${form_reference_no}\n申請職位：${job}";
        defaultTemplateCon.sc =
            "确认已收到你${submission_type}的教育局公务员职位申请书，详情如下:\n\n\n参考编号：${form_reference_no}\n申请职位：${job}";
    }
    let threeTemplateConEN =
        "Form name: ${form_name}\t\nURL: ${url}\nReference number: ${form_reference_no}";

    let form072TemplateCon =
        "Type of submission: ${submission_type}\t\nURL: ${url}\nReference number: ${form_reference_no}\nStatus: ${status}";

    let defaultTemplateTitle = "(No. ${form_reference_no})";
    const form101TemplateTitle = {
        en: "",
        tc: "",
        sc: "",
    };
    let twoTemplateTitle =
        "(No. ${form_reference_no}) (${school_lv_type} - ${treasury_school_code})";

    let tpyeArr = [7, 8, 9, 11]; // 7 = ssdo 8 = sdo 9 = csdo 11= clericalStaff
    let formFlag = Constant?.emailTemplateFormList.includes(formId.toString());
    let temp = {
        title: "",
        content: "",
    };

    // 1.所有Form(7 = ssdo 8 = sdo 9 = csdo 11= clericalStaff)類型返回的title,content是一樣的
    // 2.emailTemplateFormList類的Form其他類型返回twoTemplate
    // 3.不是emailTemplateFormList類的Form其他類型返回defaultTemplate
    if (formFlag) {
        if (tpyeArr.includes(type)) {
            temp.title = defaultTemplateTitle;
            temp.content = threeTemplateConEN;
        } else {
            temp.title = twoTemplateTitle;
            temp.content = twoTemplateCon[lang];
        }
        return temp;
    } else {
        if (tpyeArr.includes(type)) {
            temp.title = defaultTemplateTitle;
            temp.content =
                formId == "72" ? form072TemplateCon : threeTemplateConEN;
        } else {
            temp.title =
                formId == "101"
                    ? form101TemplateTitle[lang]
                    : defaultTemplateTitle;
            temp.content =
                /* formId == "103"
                    ? defaultTemplateConNew[lang]
                    : */ formId == "104" && type < 2
                    ? defaultTemplateConForm104[lang]
                    : formId == "107" &&
                      type === 0 &&
                      roleIndex !== 6 &&
                      roleIndex !== 7
                    ? applicantTemplateConForm107[lang]
                    : defaultTemplateCon[lang];
        }
        return temp;
    }
}

export const translateSSDO = (formId, data, type, lang, t, isSpilt) => {
    let val = "";
    console.log("SMO:isEmpty(data)", isEmpty(data));
    if (isEmpty(data) || data === null || data === "null") {
        return data;
    }
    let str = "";

    switch (type) {
        case "CSDO":
            str = lang == "sc" ? "总学校发展主任" : "總學校發展主任";
            break;
        case "SDO":
            str = lang == "sc" ? "学校发展主任" : "學校發展主任";
            break;
        default:
            str = lang == "sc" ? "高级学校发展主任" : "高級學校發展主任";
            break;
    }
    let formFlag = Constant?.translateSsdoFormList.includes(formId.toString());
    isSpilt = isSpilt ? isSpilt : !data.includes(type);
    val =
        data?.includes(type) && data.startsWith(type)
            ? `${data?.split(type)[1]}`
            : data;
    if (lang != "en") {
        if (formFlag) {
            let index1 = data?.indexOf("(");
            let index2 = data?.indexOf(")");
            if (
                !t(`ssdo`, {
                    returnObjects: true,
                })[data?.substring(index1 + 1, index2).toUpperCase()]
            ) {
                val =
                    data && data.includes(type)
                        ? `${str}${data?.split(type)[1]}`
                        : data;
            } else {
                val =
                    str +
                    val?.replace(
                        data?.substring(index1 + 1, index2),
                        t(`ssdo`, {
                            returnObjects: true,
                        })[data?.substring(index1 + 1, index2).toUpperCase()]
                    );
                val = val.replace("(", "（");
                val = val.replace(")", "）");
            }
        } else {
            console.log("SMO:BBB");
            let index1 = data?.indexOf("(");
            let index2 = data?.indexOf(")");
            let _val = "";
            if (
                !t(`ssdo`, {
                    returnObjects: true,
                })[data?.substring(index1 + 1, index2).toUpperCase()]
            ) {
                _val =
                    data && data.includes(type) ? data?.split(type)[1] : data;
            } else {
                _val = val?.replace(
                    data?.substring(index1 + 1, index2),
                    t(`ssdo`, {
                        returnObjects: true,
                    })[data?.substring(index1 + 1, index2).toUpperCase()]
                );
                _val = _val.replace("(", "（");
                _val = _val.replace(")", "）");
            }
            if (!isSpilt) {
                val = str + _val;
            } else {
                val = _val;
            }
        }
    } else {
        val = data;
    }
    return val;
};
export const dateFormat = (date) => {
    let timeStamp = "";
    if (date.includes("年")) {
        timeStamp = new Date(
            Date.parse(
                date.replace("年", "/").replace("月", "/").replace("日", "")
            )
        );
    } else {
        if (date.includes("/")) {
            timeStamp = Date.parse(date);
        } else {
            timeStamp = new Date(Date.parse(date.replace(/-/g, "/")));
        }
    }
    return timeStamp;
};

export const resetForm101TempData = (
    jsonResponse,
    fullJsonObjData,
    exerciseParameters,
    i18n
) => {
    const checkedFullJsonObjData = {
        jsonResponse,
        fullJsonObjData,
    };
    if (
        isEmpty(
            exerciseParameters?.find(
                (exercise) => exercise?.schoolyear === jsonResponse?.schoolYear
            )
        )
    ) {
        checkedFullJsonObjData.jsonResponse.schoolYear = "";
        checkedFullJsonObjData.jsonResponse.noInPdfTitle = "";
        checkedFullJsonObjData.jsonResponse.exerciseType = "";
        checkedFullJsonObjData.jsonResponse.eligibleSchoolType = "";
        checkedFullJsonObjData.jsonResponse.districtOrPlace = "";
        checkedFullJsonObjData.jsonResponse.locationPreferenceGp = [
            {
                itemNo: "",
                location: "",
                priority: "",
            },
        ];
        checkedFullJsonObjData.fullJsonObjData.currentStep = "SelectType";
    } else if (
        isEmpty(
            exerciseParameters?.find(
                (exercise) =>
                    exercise?.schoolyear === jsonResponse?.schoolYear &&
                    exercise?.noInPdfTitle?.[`${i18n.language}Text`] ===
                        jsonResponse?.noInPdfTitle
            )
        )
    ) {
        checkedFullJsonObjData.jsonResponse.noInPdfTitle = "";
        checkedFullJsonObjData.jsonResponse.exerciseType = "";
        checkedFullJsonObjData.jsonResponse.eligibleSchoolType = "";
        checkedFullJsonObjData.jsonResponse.districtOrPlace = "";
        checkedFullJsonObjData.jsonResponse.locationPreferenceGp = [
            {
                itemNo: "",
                location: "",
                priority: "",
            },
        ];
        checkedFullJsonObjData.fullJsonObjData.currentStep = "SelectType";
    } else if (
        exerciseParameters?.find(
            (exercise) =>
                exercise?.schoolyear === jsonResponse?.schoolYear &&
                exercise?.noInPdfTitle?.[`${i18n.language}Text`] ===
                    jsonResponse?.noInPdfTitle
        )?.type !== jsonResponse?.exerciseType
    ) {
        checkedFullJsonObjData.jsonResponse.exerciseType = "";
        checkedFullJsonObjData.jsonResponse.eligibleSchoolType = "";
        checkedFullJsonObjData.jsonResponse.districtOrPlace = "";
        checkedFullJsonObjData.jsonResponse.locationPreferenceGp = [
            {
                itemNo: "",
                location: "",
                priority: "",
            },
        ];
        checkedFullJsonObjData.fullJsonObjData.currentStep = "SelectType";
    }
    return checkedFullJsonObjData;
};

export function downloadURLFile(path, filename, dispatch) {
    /**
     * This function is fix cant download file by URL when idle in the page
     */
    const option = {
        url: path + filename,
    };
    dispatch(send("DOWNLOAD_ZIP", option))
        .then((res) => res.blob())
        .then((result) => {
            let aTag = document.createElement("a");
            aTag.href = URL.createObjectURL(result);
            aTag.download = filename;
            aTag.click();
            URL.revokeObjectURL(result);
        })
        .catch((error) => {
            console.log(error);
        });
}

export const objHasValidValue = (obj) => {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (isNotEmpty(obj[key])) {
                return true;
            }
        }
    }
    return false;
};

export const mapIamsmartContent = (strData, map) => {
    console.log("mapIamsmartContent strData========", strData);
    let enName = strData?.enName?.UnstructuredName;
    let chName = strData?.chName?.ChineseName;
    let prefix = strData?.prefix;
    let gender = strData?.gender;
    let idNo = strData?.idNo?.Identification;
    let checkDigit = strData?.idNo?.CheckDigit;
    console.log("idNo=====================", idNo);
    let mobileNumber = strData?.mobileNumber?.SubscriberNumber;
    let mobileNumberCountryCode = strData?.mobileNumber?.CountryCode;
    let homeTelNumber = strData?.homeTelNumber?.SubscriberNumber;
    let homeTelNumberCountryCode = strData?.homeTelNumber?.CountryCode;
    let officeTelNumber = strData?.officeTelNumber?.SubscriberNumber;
    let officeTelNumberCountryCode = strData?.officeTelNumber?.CountryCode;
    let emailAddress = strData?.emailAddress;
    let birthDate = strData?.birthDate;
    let chiPremisesAddress = "";
    let engPremisesAddress = "";
    let chiFreeFormatAddress = "";
    let engFreeFormatAddress = "";
    let chiPostBoxAddress = "";
    let engPostBoxAddress = "";
    let chiPremisesAddressPostal = "";
    let engPremisesAddressPostal = "";
    let chiFreeFormatAddressPostal = "";
    let engFreeFormatAddressPostal = "";
    let chiPostBoxAddressPostal = "";
    let engPostBoxAddressPostal = "";
    let residentialAddressObj = {};
    let postalAddressObj = {};
    let addressSplited = map["addressSplited"];
    console.log("start handleAddressLangue========");
    let addressLang = handleAddressLangue(map); //form16
    let boolenChi = false;
    let boolenEng = false;

    // 检查 map 中 residentialAddress 是否同时需要中英文（如 Form042）
    let needDualLanguage = false;
    let hasChiAddress = false;
    let hasEngAddress = false;
    Object.keys(map).forEach((key) => {
        if (map[key]?.iasName === "residentialAddress") {
            if (map[key]?.lang === "Chi") hasChiAddress = true;
            if (map[key]?.lang === "Eng") hasEngAddress = true;
        }
    });
    needDualLanguage = hasChiAddress && hasEngAddress;
    console.log("needDualLanguage=======" + needDualLanguage);

    if (addressLang === "Chi") {
        boolenChi = true;
    }
    console.log("boolenChi=======" + boolenChi);
    if (addressLang === "Eng") {
        boolenEng = true;
    }
    console.log("boolenEng=======" + boolenEng);
    if (isObjectNotEmpty(strData?.residentialAddress)) {
        let residentialAddress = strData?.residentialAddress;

        if (needDualLanguage) {
            // 双语模式：提取所有语言的地址
            console.log("Dual language mode for residentialAddress");
            if (
                "ChiPremisesAddress" in residentialAddress ||
                "EngPremisesAddress" in residentialAddress
            ) {
                if ("ChiPremisesAddress" in residentialAddress) {
                    console.log("in ChiPremisesAddress (dual mode)");
                    if (addressSplited) {
                        residentialAddressObj =
                            getSplitChiPremisesAddress(residentialAddress);
                    } else {
                        chiPremisesAddress =
                            getChiPremisesAddress(residentialAddress);
                    }
                }
                if ("EngPremisesAddress" in residentialAddress) {
                    console.log("in EngPremisesAddress (dual mode)");
                    if (addressSplited) {
                        residentialAddressObj =
                            getSplitEngPremisesAddress(residentialAddress);
                    } else {
                        engPremisesAddress =
                            getEngPremisesAddress(residentialAddress);
                    }
                }
            } else if ("FreeFormatAddress" in residentialAddress) {
                let freeFormatAddressLang =
                    strData?.residentialAddress?.FreeFormatAddress
                        ?.LanguageCode;
                if (isObjectNotEmpty(freeFormatAddressLang)) {
                    if (freeFormatAddressLang === "zh") {
                        chiFreeFormatAddress =
                            getChiFreeFormatAddress(residentialAddress);
                    }
                    if (freeFormatAddressLang === "en") {
                        engFreeFormatAddress =
                            getEngFreeFormatAddress(residentialAddress);
                    }
                }
            } else if ("PostBoxAddress" in residentialAddress) {
                let chiPostBox =
                    strData?.residentialAddress?.PostBoxAddress?.ChiPostBox;
                if (isObjectNotEmpty(chiPostBox)) {
                    chiPostBoxAddress =
                        getChiPostBoxAddress(residentialAddress);
                }
                let engPostBox =
                    strData?.residentialAddress?.PostBoxAddress?.EngPostBox;
                if (isObjectNotEmpty(engPostBox)) {
                    engPostBoxAddress =
                        getEngPostBoxAddress(residentialAddress);
                }
            }
        } else {
            if ("ChiPremisesAddress" in residentialAddress && boolenChi) {
                console.log("in ChiPremisesAddress=======" + boolenChi);
                if (addressSplited) {
                    residentialAddressObj =
                        getSplitChiPremisesAddress(residentialAddress);
                } else {
                    chiPremisesAddress =
                        getChiPremisesAddress(residentialAddress);
                }
            } else if (
                "EngPremisesAddress" in residentialAddress &&
                boolenEng
            ) {
                console.log("in EngPremisesAddress=======" + boolenEng);
                if (addressSplited) {
                    residentialAddressObj =
                        getSplitEngPremisesAddress(residentialAddress);
                } else {
                    engPremisesAddress =
                        getEngPremisesAddress(residentialAddress);
                }
            } else if ("FreeFormatAddress" in residentialAddress) {
                let freeFormatAddressLang =
                    strData?.residentialAddress?.FreeFormatAddress
                        ?.LanguageCode;
                if (isObjectNotEmpty(freeFormatAddressLang)) {
                    if (freeFormatAddressLang === "zh" && boolenChi) {
                        chiFreeFormatAddress =
                            getChiFreeFormatAddress(residentialAddress);
                    } else if (freeFormatAddressLang === "en") {
                        engFreeFormatAddress =
                            getEngFreeFormatAddress(residentialAddress);
                    }
                }
            } else if ("PostBoxAddress" in residentialAddress) {
                let chiPostBox =
                    strData?.residentialAddress?.PostBoxAddress?.ChiPostBox;
                if (isObjectNotEmpty(chiPostBox) && boolenChi) {
                    chiPostBoxAddress =
                        getChiPostBoxAddress(residentialAddress);
                }
                let engPostBox =
                    strData?.residentialAddress?.PostBoxAddress?.EngPostBox;
                if (isObjectNotEmpty(engPostBox) && boolenEng) {
                    engPostBoxAddress =
                        getEngPostBoxAddress(residentialAddress);
                }
            } else {
                //console.log("error in residentialAddress ");
            }
        }
    }
    if (isObjectNotEmpty(strData?.postalAddress)) {
        let postalAddress = strData?.postalAddress;
        if ("ChiPremisesAddress" in postalAddress && boolenChi) {
            chiPremisesAddressPostal = getChiPremisesAddress(postalAddress);
        } else if ("EngPremisesAddress" in postalAddress && boolenEng) {
            engPremisesAddressPostal = getEngPremisesAddress(postalAddress);
        } else if ("FreeFormatAddress" in postalAddress) {
            let freeFormatAddressLang =
                strData?.postalAddress?.FreeFormatAddress?.LanguageCode;
            if (isObjectNotEmpty(freeFormatAddressLang)) {
                if (freeFormatAddressLang === "zh" && boolenChi) {
                    chiFreeFormatAddressPostal =
                        getChiFreeFormatAddress(postalAddress);
                } else if (freeFormatAddressLang === "en" && boolenEng) {
                    engFreeFormatAddressPostal =
                        getEngFreeFormatAddress(postalAddress);
                }
            }
        } else if ("PostBoxAddress" in postalAddress) {
            let chiPostBox = strData?.postalAddress?.PostBoxAddress?.ChiPostBox;
            if (isObjectNotEmpty(chiPostBox) && boolenChi) {
                chiPostBoxAddressPostal = getChiPostBoxAddress(postalAddress);
            }
            let engPostBox = strData?.postalAddress?.PostBoxAddress?.EngPostBox;
            if (isObjectNotEmpty(engPostBox) && boolenEng) {
                engPostBoxAddressPostal = getEngPostBoxAddress(postalAddress);
            }
        } else {
            //console.log("error in postalAddress ");
        }
    }
    let iamsmartContentobj = {
        enName,
        chName,
        prefix,
        gender,
        idNo,
        checkDigit,
        mobileNumber,
        mobileNumberCountryCode,
        homeTelNumber,
        homeTelNumberCountryCode,
        officeTelNumber,
        officeTelNumberCountryCode,
        emailAddress,
        birthDate,
        chiPremisesAddress,
        engPremisesAddress,
        chiFreeFormatAddress,
        engFreeFormatAddress,
        chiPostBoxAddress,
        engPostBoxAddress,
        chiPremisesAddressPostal,
        engPremisesAddressPostal,
        chiFreeFormatAddressPostal,
        engFreeFormatAddressPostal,
        chiPostBoxAddressPostal,
        engPostBoxAddressPostal,
    };
    console.log(
        "residentialAddressObj==" + JSON.stringify(residentialAddressObj)
    );
    let residentialAddressObjEmpty = { residentialAddressObjEmptyFlag: false };
    if (isObjectEmpty(residentialAddressObj)) {
        residentialAddressObjEmpty = { residentialAddressObjEmptyFlag: true };
    }
    let iamsmartContent = Object.assign(
        iamsmartContentobj,
        residentialAddressObj,
        postalAddressObj,
        residentialAddressObjEmpty
    );
    return iamsmartContent;
};

export const handleAddressLangue = (map) => {
    let addressLang = map["formLang"];
    console.log("map addressLang==" + addressLang);
    if (isEmpty(addressLang)) {
        addressLang = "Eng";
    }
    return addressLang;
};

export const getChiPremisesAddress = (addressObj) => {
    let chiPremisesAddressStr = "";
    let buildingNameStr = addressObj.ChiPremisesAddress?.BuildingName;
    if (isObjectEmpty(buildingNameStr)) {
        return chiPremisesAddressStr;
    }
    let chiPremisesAddressObj = addressObj.ChiPremisesAddress;
    if (isObjectNotEmpty(chiPremisesAddressObj)) {
        let region = addressObj?.ChiPremisesAddress?.Region;
        if (isObjectNotEmpty(region)) {
            chiPremisesAddressStr = chiPremisesAddressStr + region;
        }
        let subDistrict =
            addressObj?.ChiPremisesAddress?.ChiDistrict?.["Sub-district"];
        if (isObjectNotEmpty(subDistrict)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + subDistrict;
        }
        let streetName = addressObj?.ChiPremisesAddress?.ChiStreet?.StreetName;
        if (isObjectNotEmpty(streetName)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + streetName;
            let buildingNoFrom =
                addressObj?.ChiPremisesAddress?.ChiStreet?.BuildingNoFrom;
            if (isObjectNotEmpty(buildingNoFrom)) {
                chiPremisesAddressStr =
                    chiPremisesAddressStr + " " + buildingNoFrom;
            }
        }
        let estateName = addressObj?.ChiPremisesAddress?.ChiEstate?.EstateName;
        if (isObjectNotEmpty(estateName)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + estateName;
        }
        let phaseName =
            addressObj?.ChiPremisesAddress?.ChiEstate?.ChiPhase?.PhaseName;
        if (isObjectNotEmpty(phaseName)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + phaseName;
        }
        let blockNo = addressObj?.ChiPremisesAddress?.ChiBlock?.BlockNo;
        if (isObjectNotEmpty(blockNo)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + blockNo;
            let blockDescriptor =
                addressObj?.ChiPremisesAddress?.ChiBlock?.BlockDescriptor;
            if (isObjectNotEmpty(blockDescriptor)) {
                chiPremisesAddressStr = chiPremisesAddressStr + blockDescriptor;
            }
        }
        let buildingName = addressObj?.ChiPremisesAddress?.BuildingName;
        if (isObjectNotEmpty(buildingName)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + buildingName;
        }
        let floorNum =
            addressObj?.ChiPremisesAddress?.Chi3dAddress?.ChiFloor?.FloorNum;
        if (isObjectNotEmpty(floorNum)) {
            chiPremisesAddressStr =
                chiPremisesAddressStr + " " + floorNum + "樓";
        }
        let unitNo =
            addressObj?.ChiPremisesAddress?.Chi3dAddress?.ChiUnit?.UnitNo;
        if (isObjectNotEmpty(unitNo)) {
            chiPremisesAddressStr = chiPremisesAddressStr + " " + unitNo;
            let unitDescriptor =
                addressObj?.ChiPremisesAddress?.Chi3dAddress?.ChiUnit
                    ?.UnitDescriptor;
            if (isObjectNotEmpty(unitDescriptor)) {
                chiPremisesAddressStr = chiPremisesAddressStr + unitDescriptor;
            }
        }
    }
    return chiPremisesAddressStr;
};

export const getSplitChiPremisesAddress = (addressObj) => {
    let obj = {};
    let splitChiPremisesAddressObj = {};
    let buildingNameStr = addressObj.ChiPremisesAddress?.BuildingName;
    if (isObjectEmpty(buildingNameStr)) {
        return splitChiPremisesAddressObj;
    }
    let chiPremisesAddressObj = addressObj.ChiPremisesAddress;
    if (isObjectNotEmpty(chiPremisesAddressObj)) {
        let region = addressObj?.ChiPremisesAddress?.Region;
        if (isObjectNotEmpty(region)) {
            obj = { country: region };
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let subDistrict =
            addressObj?.ChiPremisesAddress?.ChiDistrict?.["Sub-district"];
        if (isObjectNotEmpty(subDistrict)) {
            obj = { "sub-district": subDistrict };
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let streetName = addressObj?.ChiPremisesAddress?.ChiStreet?.StreetName;
        if (isObjectNotEmpty(streetName)) {
            obj = { road: streetName };
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let estateName = addressObj?.ChiPremisesAddress?.ChiEstate?.EstateName;
        if (isObjectNotEmpty(estateName)) {
            obj = { estate: estateName };
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let phaseName =
            addressObj?.ChiPremisesAddress?.ChiEstate?.ChiPhase?.PhaseName;
        if (isObjectNotEmpty(phaseName)) {
            obj = { phase: phaseName };
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let buildingName = addressObj?.ChiPremisesAddress?.BuildingName;
        if (isObjectNotEmpty(buildingName)) {
            let blockNo = addressObj?.ChiPremisesAddress?.ChiBlock?.BlockNo;
            obj = { block: buildingName };
            if (isObjectNotEmpty(blockNo)) {
                obj = { block: buildingName + " " + blockNo };
                let blockDescriptor =
                    addressObj?.ChiPremisesAddress?.ChiBlock?.BlockDescriptor;
                if (isObjectNotEmpty(blockDescriptor)) {
                    obj = {
                        block: buildingName + " " + blockNo + blockDescriptor,
                    };
                }
            }
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let floorNum =
            addressObj?.ChiPremisesAddress?.Chi3dAddress?.ChiFloor?.FloorNum;
        if (isObjectNotEmpty(floorNum)) {
            obj = { floor: floorNum + "樓" };
            splitChiPremisesAddressObj = Object.assign(
                splitChiPremisesAddressObj,
                obj
            );
        }
        let unitNo =
            addressObj?.ChiPremisesAddress?.Chi3dAddress?.ChiUnit?.UnitNo;
        if (isObjectNotEmpty(unitNo)) {
            obj = { flat: unitNo };
            let unitDescriptor =
                addressObj?.ChiPremisesAddress?.Chi3dAddress?.ChiUnit
                    ?.UnitDescriptor;
            if (isObjectNotEmpty(unitDescriptor)) {
                obj = { flat: unitNo + unitDescriptor };
                splitChiPremisesAddressObj = Object.assign(
                    splitChiPremisesAddressObj,
                    obj
                );
            }
        }
    }
    return splitChiPremisesAddressObj;
};

export const getEngPremisesAddress = (addressObj) => {
    let engPremisesAddressStr = "";
    let buildingNameStr = addressObj?.EngPremisesAddress?.BuildingName;
    if (isObjectEmpty(buildingNameStr)) {
        return engPremisesAddressStr;
    }

    let unitDescriptor =
        addressObj?.EngPremisesAddress?.Eng3dAddress?.EngUnit?.UnitDescriptor;
    if (isObjectNotEmpty(unitDescriptor)) {
        engPremisesAddressStr = engPremisesAddressStr + unitDescriptor;
    }
    let unitNo = addressObj?.EngPremisesAddress?.Eng3dAddress?.EngUnit?.UnitNo;
    if (isObjectNotEmpty(unitNo)) {
        engPremisesAddressStr = engPremisesAddressStr + " " + unitNo;
    }
    let floorNum =
        addressObj?.EngPremisesAddress?.Eng3dAddress?.EngFloor?.FloorNum;
    if (isObjectNotEmpty(floorNum)) {
        if (isObjectEmpty(engPremisesAddressStr)) {
            engPremisesAddressStr = floorNum + "/F";
        } else {
            engPremisesAddressStr =
                engPremisesAddressStr + ", " + floorNum + "/F";
        }
    }
    let blockDescriptor =
        addressObj?.EngPremisesAddress?.EngBlock?.BlockDescriptor;
    if (isObjectNotEmpty(blockDescriptor)) {
        if (isObjectEmpty(engPremisesAddressStr)) {
            engPremisesAddressStr = blockDescriptor;
        } else {
            engPremisesAddressStr =
                engPremisesAddressStr + ", " + blockDescriptor;
        }
    }
    let blockNo = addressObj?.EngPremisesAddress?.EngBlock?.BlockNo;
    if (isObjectNotEmpty(blockNo)) {
        engPremisesAddressStr = engPremisesAddressStr + " " + blockNo;
    }
    let buildingName = addressObj?.EngPremisesAddress?.BuildingName;
    if (isObjectNotEmpty(buildingName)) {
        if (isObjectEmpty(engPremisesAddressStr)) {
            engPremisesAddressStr = buildingName;
        } else {
            engPremisesAddressStr = engPremisesAddressStr + ", " + buildingName;
        }
    }
    let estateName = addressObj?.EngPremisesAddress?.EngEstate?.EstateName;
    if (isObjectNotEmpty(estateName)) {
        if (isObjectEmpty(engPremisesAddressStr)) {
            engPremisesAddressStr = estateName;
        } else {
            engPremisesAddressStr = engPremisesAddressStr + ", " + estateName;
        }
    }
    let phaseName =
        addressObj?.EngPremisesAddress?.EngEstate?.EngPhase?.PhaseName;
    if (isObjectNotEmpty(phaseName)) {
        engPremisesAddressStr = engPremisesAddressStr + " " + phaseName;
    }
    let streetName = addressObj?.EngPremisesAddress?.EngStreet?.StreetName;
    if (isObjectNotEmpty(streetName)) {
        if (isObjectEmpty(engPremisesAddressStr)) {
            engPremisesAddressStr = streetName;
        } else {
            engPremisesAddressStr = engPremisesAddressStr + ", " + streetName;
        }
    }
    let subDistrict =
        addressObj?.EngPremisesAddress?.EngDistrict?.["Sub-district"];
    if (isObjectNotEmpty(subDistrict)) {
        if (isObjectEmpty(engPremisesAddressStr)) {
            engPremisesAddressStr = subDistrict;
        } else {
            engPremisesAddressStr = engPremisesAddressStr + ", " + subDistrict;
        }
    }
    let region = addressObj?.EngPremisesAddress?.Region;
    if (isObjectNotEmpty(region)) {
        let regionStr = "";
        if (region === "KLN") {
            regionStr = "Kowloon";
        } else if (region === "HK") {
            regionStr = "Hong Kong";
        } else if (region === "NT") {
            regionStr = "New Territories";
        }
        engPremisesAddressStr = engPremisesAddressStr + ", " + regionStr;
    }
    return engPremisesAddressStr;
};

export const getSplitEngPremisesAddress = (addressObj) => {
    let obj = {};
    let splitEngPremisesAddressObj = {};
    let buildingNameStr = addressObj?.EngPremisesAddress?.BuildingName;
    if (isObjectEmpty(buildingNameStr)) {
        return splitEngPremisesAddressObj;
    }
    let unitNo = addressObj?.EngPremisesAddress?.Eng3dAddress?.EngUnit?.UnitNo;
    if (isObjectNotEmpty(unitNo)) {
        let unitDescriptor =
            addressObj?.EngPremisesAddress?.Eng3dAddress?.EngUnit
                ?.UnitDescriptor;
        if (isObjectNotEmpty(unitDescriptor)) {
            obj = { flat: unitNo + unitDescriptor };
            splitEngPremisesAddressObj = Object.assign(
                splitEngPremisesAddressObj,
                obj
            );
        }
    }

    let floorNum =
        addressObj?.EngPremisesAddress?.Eng3dAddress?.EngFloor?.FloorNum;
    if (isObjectNotEmpty(floorNum)) {
        //engPremisesAddressStr = engPremisesAddressStr +", "+ floorNum +"/F";
        obj = { floor: floorNum + "/F" };
        splitEngPremisesAddressObj = Object.assign(
            splitEngPremisesAddressObj,
            obj
        );
    }

    let buildingName = addressObj?.EngPremisesAddress?.BuildingName;
    if (isObjectNotEmpty(buildingName)) {
        //engPremisesAddressStr = engPremisesAddressStr +", "+ buildingName;
        let blockNo = addressObj?.EngPremisesAddress?.EngBlock?.BlockNo;
        if (isObjectNotEmpty(blockNo)) {
            //engPremisesAddressStr = engPremisesAddressStr +" "+ blockNo;
            let blockDescriptor =
                addressObj?.EngPremisesAddress?.EngBlock?.BlockDescriptor;
            if (isObjectNotEmpty(blockDescriptor)) {
                //engPremisesAddressStr = engPremisesAddressStr +", "+ blockDescriptor;
                obj = { block: blockNo + blockDescriptor + " " + buildingName };
                splitEngPremisesAddressObj = Object.assign(
                    splitEngPremisesAddressObj,
                    obj
                );
            }
        }
    }
    let estateName = addressObj?.EngPremisesAddress?.EngEstate?.EstateName;
    if (isObjectNotEmpty(estateName)) {
        //engPremisesAddressStr = engPremisesAddressStr +", "+ estateName;
        obj = { estate: estateName };
        splitEngPremisesAddressObj = Object.assign(
            splitEngPremisesAddressObj,
            obj
        );
    }
    let phaseName =
        addressObj?.EngPremisesAddress?.EngEstate?.EngPhase?.PhaseName;
    if (isObjectNotEmpty(phaseName)) {
        //engPremisesAddressStr = engPremisesAddressStr +" "+ phaseName;
        obj = { phase: phaseName };
        splitEngPremisesAddressObj = Object.assign(
            splitEngPremisesAddressObj,
            obj
        );
    }
    let streetName = addressObj?.EngPremisesAddress?.EngStreet?.StreetName;
    if (isObjectNotEmpty(streetName)) {
        //engPremisesAddressStr = engPremisesAddressStr +", "+ streetName;
        obj = { road: streetName };
        splitEngPremisesAddressObj = Object.assign(
            splitEngPremisesAddressObj,
            obj
        );
    }
    let subDistrict =
        addressObj?.EngPremisesAddress?.EngDistrict?.["Sub-district"];
    if (isObjectNotEmpty(subDistrict)) {
        //engPremisesAddressStr = engPremisesAddressStr +", "+ subDistrict;
        obj = { "sub-district": subDistrict };
        splitEngPremisesAddressObj = Object.assign(
            splitEngPremisesAddressObj,
            obj
        );
    }
    let region = addressObj?.EngPremisesAddress?.Region;
    if (isObjectNotEmpty(region)) {
        //For split address regionStr shuold be "Hong Kong" instead of "Kowloon" or "New Territories"
        let regionStr = "";
        if (region === "KLN") {
            regionStr = "Hong Kong";
        } else if (region === "HK") {
            regionStr = "Hong Kong";
        } else if (region === "NT") {
            regionStr = "Hong Kong";
        }
        //engPremisesAddressStr = engPremisesAddressStr +", "+ regionStr;
        obj = { country: regionStr };
        splitEngPremisesAddressObj = Object.assign(
            splitEngPremisesAddressObj,
            obj
        );
    }
    return splitEngPremisesAddressObj;
};

export const getChiFreeFormatAddress = (addressObj) => {
    let chiFreeFormatAddressStr = "";
    let freeFormatAddressObj = addressObj?.FreeFormatAddress;
    if (isObjectNotEmpty(freeFormatAddressObj)) {
        let addressLine1 = addressObj?.FreeFormatAddress?.AddressLine1;
        if (isObjectNotEmpty(addressLine1)) {
            chiFreeFormatAddressStr = chiFreeFormatAddressStr + addressLine1;
        }
        let addressLine2 = addressObj?.FreeFormatAddress?.AddressLine2;
        if (isObjectNotEmpty(addressLine2)) {
            chiFreeFormatAddressStr =
                chiFreeFormatAddressStr + " " + addressLine2;
        }
        let addressLine3 = addressObj?.FreeFormatAddress?.AddressLine3;
        if (isObjectNotEmpty(addressLine2)) {
            chiFreeFormatAddressStr =
                chiFreeFormatAddressStr + " " + addressLine3;
        }
    }
    return chiFreeFormatAddressStr;
};

export const getEngFreeFormatAddress = (addressObj) => {
    let engFreeFormatAddressStr = "";
    let freeFormatAddressObj = addressObj?.FreeFormatAddress;
    if (isObjectNotEmpty(freeFormatAddressObj)) {
        let addressLine1 = addressObj?.FreeFormatAddress?.AddressLine1;
        if (isObjectNotEmpty(addressLine1)) {
            engFreeFormatAddressStr = engFreeFormatAddressStr + addressLine1;
        }
        let addressLine2 = addressObj?.FreeFormatAddress?.AddressLine2;
        if (isObjectNotEmpty(addressLine2)) {
            engFreeFormatAddressStr =
                engFreeFormatAddressStr + "," + addressLine2;
        }
        let addressLine3 = addressObj?.FreeFormatAddress?.AddressLine3;
        if (isObjectNotEmpty(addressLine2)) {
            engFreeFormatAddressStr =
                engFreeFormatAddressStr + "," + addressLine3;
        }
    }
    return engFreeFormatAddressStr;
};

export const getChiPostBoxAddress = (addressObj) => {
    let chiPostBoxAddressStr = "";
    let chiPostBoxAddressObj = addressObj?.PostBoxAddress;
    if (isObjectNotEmpty(chiPostBoxAddressObj)) {
        let postOfficeRegion =
            addressObj?.PostBoxAddress?.ChiPostBox?.PostOfficeRegion;
        if (isObjectNotEmpty(postOfficeRegion)) {
            chiPostBoxAddressStr = chiPostBoxAddressStr + postOfficeRegion;
        }
        let postOffice = addressObj?.PostBoxAddress?.ChiPostBox?.PostOffice;
        if (isObjectNotEmpty(postOffice)) {
            chiPostBoxAddressStr = chiPostBoxAddressStr + " " + postOffice;
        }
        let poBoxNo = addressObj?.PostBoxAddress?.ChiPostBox?.PoBoxNo;
        if (isObjectNotEmpty(poBoxNo)) {
            chiPostBoxAddressStr =
                chiPostBoxAddressStr + " 郵政信箱" + poBoxNo + "號";
        }
    }
    return chiPostBoxAddressStr;
};

export const getEngPostBoxAddress = (addressObj) => {
    let engPostBoxAddressStr = "";
    let engPostBoxAddressObj = addressObj?.PostBoxAddress;
    if (isObjectNotEmpty(engPostBoxAddressObj)) {
        let poBoxNo = addressObj?.PostBoxAddress?.EngPostBox?.PoBoxNo;
        if (isObjectNotEmpty(poBoxNo)) {
            engPostBoxAddressStr =
                engPostBoxAddressStr + " P.O. Box " + poBoxNo;
        }
        let postOffice = addressObj?.PostBoxAddress?.EngPostBox?.PostOffice;
        if (isObjectNotEmpty(postOffice)) {
            engPostBoxAddressStr = engPostBoxAddressStr + " " + postOffice;
        }
        let postOfficeRegion =
            addressObj?.PostBoxAddress?.EngPostBox?.PostOfficeRegion;
        if (isObjectNotEmpty(postOfficeRegion)) {
            engPostBoxAddressStr =
                engPostBoxAddressStr + " " + postOfficeRegion;
        }
    }
    return engPostBoxAddressStr;
};

export const formFillFn = (
    openID,
    map,
    accessToken,
    setValue,
    dispatch,
    otherParamsMap
) => {
    if (isNotEmpty(openID)) {
        console.log("in formFillFn openID========", openID);
        console.log("in formFillFn map========", map);

        // const headers = {
        //     clientEntityName: "edbeform",
        //     businessID: openID,
        //     content: mapToStringIamsmart(map),
        // };
        console.log("start interval");

        const headersV20 = {
            accessToken,
            openID,
            profileFields: [],
            eMEFields: mapToStringIamsmart(map)?.split(","),
        };

        const optionV20 = {
            url: "/iamsmartedbv2/edbeform/profile/init",
            method: "POST",
            header: headersV20,
        };
        console.log("headersV20========", JSON.stringify(headersV20));
        dispatch(sendV30(optionV20))
            .then((response) => response.text())
            .then((result) => {
                //SetQrLinkURL(jwtDecode(result)?.data?.action);
                console.log(result);
                let strData = jwtDecode(result)?.profile;
                let content = mapIamsmartContent(strData, map);
                const tempMap = mapIamsmartV20(
                    map,
                    content,
                    setValue,
                    otherParamsMap
                );
                console.log("tempMap========" + tempMap);
                console.log("end interval");
                dispatch(setIamsmartFieldMap(tempMap));
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    }
};

export const anonASFormFillFn = (
    iasTokenMap,
    map,
    combineCallProfile,
    setValue,
    dispatch
) => {
    let strData = combineCallProfile;
    console.log("anonASFormFillFn  strData=======", strData);
    let content = mapIamsmartContent(strData, map);
    const tempMap = mapIamsmartV20(map, content, setValue);
    console.log("anonASFormFillFn tempMap========" + tempMap);
    console.log("anonASFormFillFn end interval");
    dispatch(setIamsmartFieldMap(tempMap));
};

export const anonASFormFillFnWithApi = (
    iasOpenID,
    accessToken,
    map,
    setValue,
    dispatch,
    otherParamsMap,
    updateFieldMapHandle = () => {}
) => {
    console.log(
        "anonASFormFillFnWithApi otherParamsMap =====" +
            JSON.stringify(otherParamsMap)
    );
    let headersV20 = {
        accessToken,
        openID: iasOpenID,
        profileFields: [],
        eMEFields: mapToStringIamsmart(map)?.split(","),
    };
    let optionV20 = {
        url: "/iamsmartedbv2/edbeform/profile/init",
        method: "POST",
        header: headersV20,
    };
    console.log("headersV20========", JSON.stringify(headersV20));
    dispatch(sendV30(optionV20))
        .then((response) => response.text())
        .then((result) => {
            //SetQrLinkURL(jwtDecode(result)?.data?.action);
            console.log(result);
            let strData = jwtDecode(result)?.profile;
            console.log("anonASFormFillFnWithApi  strData=======", strData);
            //dispatch(initIamsmartCombineCallProfile(strData));
            let content = mapIamsmartContent(strData, map);
            const tempMap = mapIamsmartV20(
                map,
                content,
                setValue,
                otherParamsMap
            );
            console.log("anonASFormFillFnWithApi tempMap========" + tempMap);
            console.log("anonASFormFillFnWithApi end interval");
            dispatch(setIamsmartFieldMap(tempMap));
            setTimeout(() => {
                updateFieldMapHandle();
            }, 100);
        })
        .catch((error) => {
            console.log("anonASFormFillFnWithApi fetch error: ", error);
        });
};

export const getDataByOpenIdAndAccessToken = (
    openID,
    accessToken,
    map,
    dispatch
) => {
    const headersV20 = {
        accessToken: accessToken,
        openID: openID,
        profileFields: [],
        eMEFields: mapToStringIamsmart(map)?.split(","),
    };

    const optionV20 = {
        url: "/iamsmartedbv2/edbeform/profile/init",
        method: "POST",
        header: headersV20,
    };
    console.log("headersV20========", JSON.stringify(headersV20));
    return dispatch(sendV30(optionV20))
        .then((response) => response)
        .then((response) => response.text());
};

export const capitalizeFirstLetter = (str) => {
    return str?.toLowerCase()?.replace(/\b\w+\b/g, function (word) {
        return word?.substring(0, 1)?.toUpperCase() + word?.substring(1);
    });
};

export const getIsWithinDeadlineFormTemp = (formId, params, status) => {
    let isWithinDeadline = true;
    let checkStatus = true;
    const deadlineKeys = Constant?.submitDeadlineKey || [];
    const deadlineKey = deadlineKeys?.[formId]?.[0];

    if (isEmpty(status) || (isNotEmpty(status) && status > -1 && status < 10)) {
        checkStatus = false;
    }

    if (Array.isArray(deadlineKey)) {
        let startDate = isNotEmpty(params?.[deadlineKey?.[0]])
            ? moment(params?.[deadlineKey?.[0]], "DD/MM/YYYY", true)
            : "";
        let deadline = isNotEmpty(params?.[deadlineKey?.[1]])
            ? moment(params?.[deadlineKey?.[1]], "DD/MM/YYYY", true)
            : "";
        if (isNotEmpty(startDate) && isNotEmpty(deadline)) {
            if (
                startDate.isValid() === false ||
                deadline.isValid() === false ||
                (startDate.isValid() &&
                    deadline.isValid() &&
                    moment(new Date()).isBetween(
                        startDate,
                        deadline,
                        "days",
                        "[]"
                    ) === false &&
                    checkStatus === false)
            ) {
                isWithinDeadline = false;
            }
        }
    } else {
        const deadlineDate = isNotEmpty(params?.[deadlineKey])
            ? moment(params?.[deadlineKey], "DD/MM/YYYY", true)
            : "";
        if (isNotEmpty(deadlineDate)) {
            if (
                deadlineDate.isValid() === false ||
                (deadlineDate.isValid() === true &&
                    moment(deadlineDate).diff(moment(), "days") < 0 &&
                    checkStatus === false)
            ) {
                isWithinDeadline = false;
            }
        }
    }
    return isWithinDeadline;
};

function generateFallbackUUID() {
    let d = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
    );
    return uuid;
}

export const generateV4UUID = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    try {
        const buffer = new Uint8Array(16);
        crypto.getRandomValues(buffer);

        // 设置UUID版本和变体
        buffer[6] = (buffer[6] & 0x0f) | 0x40; // 版本4
        buffer[8] = (buffer[8] & 0x3f) | 0x80; // 变体1

        // 转换为十六进制并格式化为UUID
        const hexArray = Array.from(buffer).map((b) =>
            b.toString(16).padStart(2, "0")
        );
        return [
            hexArray.slice(0, 4).join(""),
            hexArray.slice(4, 6).join(""),
            hexArray.slice(6, 8).join(""),
            hexArray.slice(8, 10).join(""),
            hexArray.slice(10, 16).join(""),
        ].join("-");
    } catch (e) {
        return generateFallbackUUID();
    }
};

export const addSignedSuffix = (filename) => {
    if (!filename) return "";

    const lastDotIndex = filename.lastIndexOf(".");
    const hasExtension = lastDotIndex > 0;

    if (!hasExtension) {
        return filename + "_signed";
    }

    const base = filename.substring(0, lastDotIndex);
    const extension = filename.substring(lastDotIndex);
    return base + "_signed" + extension;
};

export const getIsDeadLineParam = (formId, paramKey) => {
    formId = intToformId(formId);
    let isDeadLineParam = false;
    const deadlineKeys = Constant?.submitDeadlineKey || [];
    const deadlineKey = deadlineKeys?.[formId]?.[0];

    if (Array.isArray(deadlineKey)) {
        let startDateKey = isNotEmpty(deadlineKey?.[0]) ? deadlineKey?.[0] : "";
        let endDateKey = isNotEmpty(deadlineKey?.[1]) ? deadlineKey?.[1] : "";
        if (
            isNotEmpty(startDateKey) &&
            isNotEmpty(endDateKey) &&
            (startDateKey === paramKey || endDateKey === paramKey)
        ) {
            isDeadLineParam = true;
        }
    } else {
        if (isNotEmpty(deadlineKey) && deadlineKey === paramKey) {
            isDeadLineParam = true;
        }
    }
    return isDeadLineParam;
};

export const isValidDDMMYYYY = (dateStr) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(dateStr)) return false;

    const [day, month, year] = dateStr.split("/").map(Number);

    if (month < 1 || month > 12) return false;

    const daysInMonth = new Date(year, month, 0).getDate();
    return day <= daysInMonth;
};

export const findDuplicateStrnIndices = (arr, key, lang = "en") => {
    // 步骤1：收集每个strn值对应的索引
    const strnMap = new Map();
    arr.forEach((item, index) => {
        const value = item?.[key] || "";
        if (!strnMap.has(value)) {
            strnMap.set(value, []);
        }
        strnMap.get(value).push(index);
    });

    // 步骤2：过滤出重复的strn值并转换格式
    const duplicates = {};
    for (const [value, indices] of strnMap) {
        if (indices.length > 1) {
            duplicates[value] = indices.map(
                (idx) => toOrdinalString(idx + 1, lang) // 索引转位置（从1开始）
            );
        }
    }

    return duplicates;
};

// 数字转中文汉字（1-999）
export const numberToChinese = (num) => {
    const digits = ["", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    const units = ["", "十", "百"];

    if (num < 10) return digits[num];
    if (num < 20) return "十" + (num % 10 ? digits[num % 10] : "");

    let result = "";
    let numStr = num.toString();
    let len = numStr.length;

    for (let i = 0; i < len; i++) {
        const digit = parseInt(numStr[i]);
        const unit = units[len - i - 1];

        if (digit !== 0) {
            // 处理"一十X"的情况
            if (!(i === 0 && digit === 1 && unit === "十")) {
                result += digits[digit];
            }
            result += unit;
        } else if (i < len - 1 && parseInt(numStr[i + 1]) !== 0) {
            result += "零"; // 处理中间零
        }
    }

    return result;
};

// 根据语言生成序数词
export const toOrdinalString = (n, lang = "en") => {
    if (lang !== "en") {
        // 中文格式："第一位"
        return `第${numberToChinese(n)}位`;
    }

    // 英文格式："1st"
    const lastTwo = n % 100;
    if (lastTwo >= 11 && lastTwo <= 13) {
        return n + "th";
    }

    switch (n % 10) {
        case 1:
            return n + "st";
        case 2:
            return n + "nd";
        case 3:
            return n + "rd";
        default:
            return n + "th";
    }
};
